var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftware01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 299.27 284.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#New_Gradient_Swatch_1);}.cls-2{fill:url(#New_Gradient_Swatch_1-2);}.cls-3{isolation:isolate;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{opacity:0.2;fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient-4);}.cls-100,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-192,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-8,.cls-80,.cls-81,.cls-86,.cls-96,.cls-97,.cls-98,.cls-99{mix-blend-mode:screen;}.cls-8{fill:url(#Radial_Gradient_1);}.cls-101,.cls-191,.cls-193,.cls-292,.cls-318,.cls-319,.cls-321,.cls-322,.cls-323,.cls-324,.cls-338,.cls-359,.cls-360,.cls-361,.cls-87,.cls-9{mix-blend-mode:color-dodge;}.cls-9{fill:url(#New_Gradient_Swatch_copy);}.cls-10{fill:url(#linear-gradient-5);}.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-88{opacity:0.3;}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#linear-gradient-14);}.cls-20{fill:url(#linear-gradient-15);}.cls-21{fill:url(#linear-gradient-16);}.cls-22{fill:url(#linear-gradient-17);}.cls-23{fill:url(#linear-gradient-18);}.cls-24{fill:url(#linear-gradient-19);}.cls-25{fill:url(#linear-gradient-20);}.cls-26{fill:url(#linear-gradient-21);}.cls-27{fill:url(#linear-gradient-22);}.cls-28{fill:url(#linear-gradient-23);}.cls-29{fill:url(#linear-gradient-24);}.cls-30{fill:url(#linear-gradient-25);}.cls-31{fill:url(#linear-gradient-26);}.cls-32{fill:url(#linear-gradient-27);}.cls-33{fill:url(#linear-gradient-28);}.cls-34{fill:url(#linear-gradient-29);}.cls-35{fill:url(#linear-gradient-30);}.cls-36{fill:url(#linear-gradient-31);}.cls-37{fill:url(#linear-gradient-32);}.cls-38{fill:url(#linear-gradient-33);}.cls-39{fill:url(#linear-gradient-34);}.cls-40{fill:url(#linear-gradient-35);}.cls-41{fill:url(#linear-gradient-36);}.cls-42{fill:url(#linear-gradient-37);}.cls-43{fill:url(#linear-gradient-38);}.cls-44{fill:url(#linear-gradient-39);}.cls-45{fill:url(#linear-gradient-40);}.cls-46{fill:url(#linear-gradient-41);}.cls-47{fill:url(#linear-gradient-42);}.cls-48{fill:url(#linear-gradient-43);}.cls-49{fill:url(#linear-gradient-44);}.cls-50{fill:url(#linear-gradient-45);}.cls-51{fill:url(#linear-gradient-46);}.cls-52{fill:url(#linear-gradient-47);}.cls-53{fill:url(#linear-gradient-48);}.cls-54{fill:url(#linear-gradient-49);}.cls-55{fill:url(#linear-gradient-50);}.cls-56{fill:url(#linear-gradient-51);}.cls-57{fill:url(#linear-gradient-52);}.cls-58{fill:url(#linear-gradient-53);}.cls-59{fill:url(#linear-gradient-54);}.cls-60{fill:url(#linear-gradient-55);}.cls-61{fill:url(#linear-gradient-56);}.cls-62{fill:url(#linear-gradient-57);}.cls-63{fill:url(#linear-gradient-58);}.cls-64{fill:url(#linear-gradient-59);}.cls-65{fill:url(#linear-gradient-60);}.cls-66{fill:url(#linear-gradient-61);}.cls-67{fill:url(#linear-gradient-62);}.cls-68{fill:url(#linear-gradient-63);}.cls-69{fill:url(#linear-gradient-64);}.cls-70{fill:url(#linear-gradient-65);}.cls-71{fill:url(#linear-gradient-66);}.cls-72{fill:url(#linear-gradient-67);}.cls-73{fill:url(#linear-gradient-68);}.cls-74{fill:url(#linear-gradient-69);}.cls-75{fill:url(#linear-gradient-70);}.cls-76{fill:url(#linear-gradient-71);}.cls-77{fill:url(#linear-gradient-72);}.cls-78{fill:url(#linear-gradient-73);}.cls-79{fill:url(#linear-gradient-74);}.cls-80{fill:url(#linear-gradient-75);}.cls-81{fill:url(#linear-gradient-76);}.cls-82{fill:url(#linear-gradient-77);}.cls-83{fill:url(#linear-gradient-78);}.cls-84{fill:#bcbec0;}.cls-342,.cls-84,.cls-88{mix-blend-mode:multiply;}.cls-85{fill:url(#linear-gradient-79);}.cls-86{fill:url(#Radial_Gradient_1-2);}.cls-87{fill:url(#radial-gradient);}.cls-89{fill:url(#linear-gradient-80);}.cls-190,.cls-291,.cls-318,.cls-321,.cls-337,.cls-355,.cls-362,.cls-90,.cls-91,.cls-92,.cls-93{opacity:0.8;}.cls-90{fill:url(#New_Gradient_Swatch_copy_26);}.cls-91{fill:url(#New_Gradient_Swatch_copy_26-2);}.cls-92{fill:url(#New_Gradient_Swatch_copy_26-3);}.cls-93{fill:url(#New_Gradient_Swatch_copy_26-4);}.cls-94{fill:#b086cc;}.cls-292,.cls-346,.cls-351,.cls-364,.cls-365,.cls-366,.cls-95{opacity:0.9;}.cls-95{fill:url(#New_Gradient_Swatch_copy_8);}.cls-96{fill:url(#Radial_Gradient_1-3);}.cls-97{fill:url(#Radial_Gradient_1-4);}.cls-98{fill:url(#Radial_Gradient_1-5);}.cls-99{fill:url(#Radial_Gradient_1-6);}.cls-100{fill:url(#Radial_Gradient_1-7);}.cls-101,.cls-290,.cls-359{opacity:0.7;}.cls-102{fill:url(#radial-gradient-2);}.cls-103{fill:url(#radial-gradient-3);}.cls-104{fill:url(#radial-gradient-4);}.cls-105{fill:url(#radial-gradient-5);}.cls-106{fill:url(#radial-gradient-6);}.cls-107{fill:url(#radial-gradient-7);}.cls-108{fill:url(#radial-gradient-8);}.cls-109{fill:url(#radial-gradient-9);}.cls-110{fill:url(#radial-gradient-10);}.cls-111{fill:url(#radial-gradient-11);}.cls-112{fill:url(#radial-gradient-12);}.cls-113{fill:url(#radial-gradient-14);}.cls-114{fill:url(#radial-gradient-15);}.cls-115{fill:url(#radial-gradient-16);}.cls-116{fill:url(#radial-gradient-17);}.cls-117{fill:url(#radial-gradient-18);}.cls-118{fill:url(#radial-gradient-19);}.cls-119{fill:url(#radial-gradient-20);}.cls-120{fill:url(#radial-gradient-21);}.cls-121{fill:url(#radial-gradient-22);}.cls-122{fill:url(#radial-gradient-23);}.cls-123{fill:url(#radial-gradient-24);}.cls-124{fill:url(#radial-gradient-25);}.cls-125{fill:url(#radial-gradient-26);}.cls-126{fill:url(#radial-gradient-27);}.cls-127{fill:url(#radial-gradient-28);}.cls-128{fill:url(#radial-gradient-29);}.cls-129{fill:url(#radial-gradient-30);}.cls-130{fill:url(#radial-gradient-31);}.cls-131{fill:url(#radial-gradient-32);}.cls-132{fill:url(#radial-gradient-33);}.cls-133{fill:url(#radial-gradient-34);}.cls-134{fill:url(#radial-gradient-35);}.cls-135{fill:url(#radial-gradient-36);}.cls-136{fill:url(#radial-gradient-37);}.cls-137{fill:url(#radial-gradient-38);}.cls-138{fill:url(#radial-gradient-39);}.cls-139{fill:url(#radial-gradient-40);}.cls-140{fill:url(#radial-gradient-41);}.cls-141{fill:url(#radial-gradient-42);}.cls-142{fill:url(#radial-gradient-43);}.cls-143{fill:url(#radial-gradient-44);}.cls-144{fill:url(#radial-gradient-45);}.cls-145{fill:url(#radial-gradient-46);}.cls-146{fill:url(#radial-gradient-47);}.cls-147{fill:url(#radial-gradient-48);}.cls-148{fill:url(#radial-gradient-49);}.cls-149{fill:url(#radial-gradient-50);}.cls-150{fill:url(#radial-gradient-51);}.cls-151{fill:url(#radial-gradient-52);}.cls-152{fill:url(#radial-gradient-53);}.cls-153{fill:url(#radial-gradient-54);}.cls-154{fill:url(#radial-gradient-55);}.cls-155{fill:url(#radial-gradient-56);}.cls-156{fill:url(#radial-gradient-57);}.cls-157{fill:url(#radial-gradient-58);}.cls-158{fill:url(#radial-gradient-59);}.cls-159{fill:url(#radial-gradient-60);}.cls-160{fill:url(#radial-gradient-61);}.cls-161{fill:url(#radial-gradient-62);}.cls-162{fill:url(#radial-gradient-63);}.cls-163{fill:url(#radial-gradient-64);}.cls-164{fill:url(#radial-gradient-65);}.cls-165{fill:url(#radial-gradient-66);}.cls-166{fill:url(#radial-gradient-67);}.cls-167{fill:url(#radial-gradient-68);}.cls-168{fill:url(#radial-gradient-69);}.cls-169{fill:url(#radial-gradient-70);}.cls-170{fill:url(#radial-gradient-71);}.cls-171{fill:url(#radial-gradient-72);}.cls-172{fill:url(#radial-gradient-73);}.cls-173{fill:url(#radial-gradient-74);}.cls-174{fill:url(#radial-gradient-75);}.cls-175{fill:url(#radial-gradient-76);}.cls-176{fill:url(#radial-gradient-77);}.cls-177{fill:url(#radial-gradient-78);}.cls-178,.cls-325{opacity:0;}.cls-178{fill:url(#linear-gradient-81);}.cls-179,.cls-326{opacity:0.09;}.cls-179{fill:url(#linear-gradient-82);}.cls-180,.cls-327{opacity:0.18;}.cls-180{fill:url(#linear-gradient-83);}.cls-181,.cls-328{opacity:0.27;}.cls-181{fill:url(#linear-gradient-84);}.cls-182,.cls-329{opacity:0.36;}.cls-182{fill:url(#linear-gradient-85);}.cls-183,.cls-330{opacity:0.45;}.cls-183{fill:url(#linear-gradient-86);}.cls-184,.cls-331{opacity:0.55;}.cls-184{fill:url(#linear-gradient-87);}.cls-185,.cls-332{opacity:0.64;}.cls-185{fill:url(#linear-gradient-88);}.cls-186,.cls-333{opacity:0.73;}.cls-186{fill:url(#linear-gradient-89);}.cls-187,.cls-334{opacity:0.82;}.cls-187{fill:url(#linear-gradient-90);}.cls-188,.cls-335{opacity:0.91;}.cls-188{fill:url(#linear-gradient-91);}.cls-189{fill:url(#linear-gradient-92);}.cls-190{fill:url(#New_Gradient_Swatch_copy_26-5);}.cls-191{fill:url(#radial-gradient-79);}.cls-193,.cls-322,.cls-339,.cls-340,.cls-341,.cls-343,.cls-344,.cls-345,.cls-356{opacity:0.6;}.cls-194{fill:url(#linear-gradient-93);}.cls-195{fill:url(#linear-gradient-94);}.cls-196{fill:url(#New_Gradient_Swatch_copy_9);}.cls-197{fill:url(#linear-gradient-95);}.cls-198{fill:url(#linear-gradient-96);}.cls-199{fill:url(#linear-gradient-97);}.cls-200{fill:url(#New_Gradient_Swatch_copy_9-2);}.cls-201{fill:url(#linear-gradient-98);}.cls-202{fill:url(#linear-gradient-99);}.cls-203{fill:url(#linear-gradient-100);}.cls-204{fill:url(#New_Gradient_Swatch_copy_8-2);}.cls-205{fill:url(#New_Gradient_Swatch_copy_9-3);}.cls-206{fill:url(#linear-gradient-101);}.cls-207{fill:url(#New_Gradient_Swatch_copy_9-4);}.cls-208{fill:url(#linear-gradient-102);}.cls-209{fill:url(#linear-gradient-103);}.cls-210{fill:url(#New_Gradient_Swatch_copy_8-3);}.cls-211{fill:url(#linear-gradient-104);}.cls-212{fill:url(#linear-gradient-105);}.cls-213{fill:url(#New_Gradient_Swatch_copy_9-5);}.cls-214{fill:url(#linear-gradient-106);}.cls-215{fill:url(#linear-gradient-107);}.cls-216{fill:url(#linear-gradient-108);}.cls-217{fill:url(#New_Gradient_Swatch_copy_9-6);}.cls-218{fill:url(#linear-gradient-109);}.cls-219{fill:url(#New_Gradient_Swatch_copy_8-4);}.cls-220{fill:url(#linear-gradient-110);}.cls-221{fill:url(#linear-gradient-111);}.cls-222{fill:url(#New_Gradient_Swatch_copy_8-5);}.cls-223{fill:url(#linear-gradient-112);}.cls-224{fill:url(#linear-gradient-113);}.cls-225{fill:url(#linear-gradient-114);}.cls-226{fill:url(#New_Gradient_Swatch_copy_9-7);}.cls-227{fill:url(#linear-gradient-115);}.cls-228{fill:url(#linear-gradient-116);}.cls-229{fill:url(#linear-gradient-117);}.cls-230{fill:url(#New_Gradient_Swatch_copy_8-6);}.cls-231{fill:url(#linear-gradient-118);}.cls-232{fill:url(#linear-gradient-119);}.cls-233{fill:url(#linear-gradient-120);}.cls-234{fill:url(#linear-gradient-121);}.cls-235{fill:url(#linear-gradient-122);}.cls-236{fill:url(#New_Gradient_Swatch_copy_8-7);}.cls-237{fill:url(#linear-gradient-123);}.cls-238{fill:url(#linear-gradient-124);}.cls-239{fill:url(#linear-gradient-125);}.cls-240{fill:url(#New_Gradient_Swatch_copy_9-8);}.cls-241{fill:url(#New_Gradient_Swatch_copy_9-9);}.cls-242{fill:url(#New_Gradient_Swatch_copy_9-10);}.cls-243{fill:url(#linear-gradient-126);}.cls-244{fill:url(#New_Gradient_Swatch_copy_9-11);}.cls-245{fill:url(#linear-gradient-127);}.cls-246{fill:url(#linear-gradient-128);}.cls-247{fill:url(#linear-gradient-129);}.cls-248{fill:url(#New_Gradient_Swatch_copy_9-12);}.cls-249{fill:url(#linear-gradient-130);}.cls-250{fill:url(#New_Gradient_Swatch_copy_9-13);}.cls-251{fill:url(#linear-gradient-131);}.cls-252{fill:url(#linear-gradient-132);}.cls-253{fill:url(#New_Gradient_Swatch_copy_9-14);}.cls-254{fill:url(#linear-gradient-133);}.cls-255{fill:url(#linear-gradient-134);}.cls-256{fill:url(#linear-gradient-135);}.cls-257{fill:url(#linear-gradient-136);}.cls-258{fill:url(#New_Gradient_Swatch_copy_9-15);}.cls-259{fill:url(#linear-gradient-137);}.cls-260{fill:url(#linear-gradient-138);}.cls-261{fill:url(#linear-gradient-139);}.cls-262{fill:url(#New_Gradient_Swatch_copy_8-8);}.cls-263{fill:url(#linear-gradient-140);}.cls-264{fill:url(#New_Gradient_Swatch_copy_9-16);}.cls-265{fill:url(#New_Gradient_Swatch_copy_8-9);}.cls-266{fill:url(#New_Gradient_Swatch_copy_9-17);}.cls-267{fill:url(#linear-gradient-141);}.cls-268{fill:url(#linear-gradient-142);}.cls-269{fill:url(#New_Gradient_Swatch_copy_9-18);}.cls-270{fill:url(#New_Gradient_Swatch_copy_9-19);}.cls-271{fill:url(#linear-gradient-143);}.cls-272{fill:url(#New_Gradient_Swatch_copy_8-10);}.cls-273{fill:url(#linear-gradient-144);}.cls-274{fill:url(#linear-gradient-145);}.cls-275{fill:url(#linear-gradient-146);}.cls-276{fill:url(#linear-gradient-147);}.cls-277{fill:url(#linear-gradient-148);}.cls-278{fill:url(#linear-gradient-149);}.cls-279{fill:url(#linear-gradient-150);}.cls-280{fill:url(#linear-gradient-151);}.cls-281{fill:url(#linear-gradient-152);}.cls-282{fill:url(#New_Gradient_Swatch_copy_9-20);}.cls-283{fill:url(#New_Gradient_Swatch_copy_9-21);}.cls-284{fill:url(#linear-gradient-153);}.cls-285{fill:url(#linear-gradient-154);}.cls-286{fill:url(#New_Gradient_Swatch_copy_9-22);}.cls-287{fill:url(#linear-gradient-155);}.cls-288{fill:url(#linear-gradient-156);}.cls-289{mask:url(#mask);}.cls-291{fill:url(#New_Gradient_Swatch_copy_26-6);}.cls-293{fill:url(#linear-gradient-157);}.cls-294{fill:url(#linear-gradient-158);}.cls-295{fill:url(#New_Gradient_Swatch_copy_8-11);}.cls-296{fill:url(#linear-gradient-159);}.cls-297{fill:url(#linear-gradient-160);}.cls-298{fill:url(#linear-gradient-161);}.cls-299{fill:url(#New_Gradient_Swatch_copy_9-23);}.cls-300{fill:url(#linear-gradient-162);}.cls-301{fill:url(#linear-gradient-163);}.cls-302{fill:url(#linear-gradient-164);}.cls-303{fill:url(#New_Gradient_Swatch_copy_8-12);}.cls-304{fill:url(#linear-gradient-165);}.cls-305{fill:url(#linear-gradient-166);}.cls-306{fill:url(#linear-gradient-167);}.cls-307{fill:url(#linear-gradient-168);}.cls-308{fill:url(#linear-gradient-169);}.cls-309{fill:url(#New_Gradient_Swatch_copy_8-13);}.cls-310{fill:url(#linear-gradient-170);}.cls-311{fill:url(#linear-gradient-171);}.cls-312{fill:url(#linear-gradient-172);}.cls-313{fill:url(#New_Gradient_Swatch_copy_9-24);}.cls-314{fill:url(#New_Gradient_Swatch_copy_9-25);}.cls-315{fill:url(#New_Gradient_Swatch_copy_9-26);}.cls-316{fill:url(#linear-gradient-173);}.cls-317{fill:url(#New_Gradient_Swatch_copy_9-27);}.cls-319,.cls-320,.cls-321,.cls-322,.cls-323,.cls-324,.cls-359,.cls-360{fill:#7c1dc9;}.cls-319{opacity:0.25;}.cls-323{opacity:0.4;}.cls-324{opacity:0.15;}.cls-325{fill:url(#linear-gradient-174);}.cls-326{fill:url(#linear-gradient-175);}.cls-327{fill:url(#linear-gradient-176);}.cls-328{fill:url(#linear-gradient-177);}.cls-329{fill:url(#linear-gradient-178);}.cls-330{fill:url(#linear-gradient-179);}.cls-331{fill:url(#linear-gradient-180);}.cls-332{fill:url(#linear-gradient-181);}.cls-333{fill:url(#linear-gradient-182);}.cls-334{fill:url(#linear-gradient-183);}.cls-335{fill:url(#linear-gradient-184);}.cls-336{fill:url(#linear-gradient-185);}.cls-337{fill:url(#New_Gradient_Swatch_copy_7);}.cls-338{fill:url(#radial-gradient-80);}.cls-339{fill:url(#New_Gradient_Swatch_copy_26-7);}.cls-340{fill:url(#New_Gradient_Swatch_copy_26-8);}.cls-341{fill:url(#New_Gradient_Swatch_copy_26-9);}.cls-342,.cls-354,.cls-360,.cls-361{opacity:0.5;}.cls-343{fill:url(#New_Gradient_Swatch_copy_26-10);}.cls-344{fill:url(#New_Gradient_Swatch_copy_26-11);}.cls-345{fill:url(#New_Gradient_Swatch_copy_26-12);}.cls-346{fill:url(#New_Gradient_Swatch_copy_8-14);}.cls-347{fill:url(#New_Gradient_Swatch_copy_8-15);}.cls-348{fill:url(#New_Gradient_Swatch_copy_8-16);}.cls-349{fill:url(#New_Gradient_Swatch_copy_8-17);}.cls-350{fill:url(#New_Gradient_Swatch_copy_8-18);}.cls-352{fill:url(#New_Gradient_Swatch_copy_8-19);}.cls-353{mask:url(#mask-2);}.cls-355{fill:url(#New_Gradient_Swatch_copy_7-2);}.cls-356{fill:url(#New_Gradient_Swatch_copy_26-13);}.cls-357{fill:url(#New_Gradient_Swatch_copy_8-20);}.cls-358{fill:url(#New_Gradient_Swatch_copy_8-21);}.cls-361{fill:#9f19ab;}.cls-363{fill:#fff;}.cls-364{fill:url(#New_Gradient_Swatch_copy_8-22);}.cls-365{fill:url(#New_Gradient_Swatch_copy_8-23);}.cls-366{fill:url(#New_Gradient_Swatch_copy_8-24);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    x1: 112.3,
    y1: 185.91,
    x2: 89.25,
    y2: 224.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    x1: 158.02,
    y1: 141.12,
    x2: 128.27,
    y2: 193.87,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 16.7,
    y1: 205.27,
    x2: 272.45,
    y2: 205.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#100041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#210243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#25084b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2c1358"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#351f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#422c73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#584188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#765fa7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#7e67ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#5c468d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#442e75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#362066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2a1155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#230446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#100041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2.59,
    y1: 198.57,
    x2: 373.83,
    y2: 198.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#290f52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#100041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16.7,
    y1: 237.92,
    x2: 272.45,
    y2: 237.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 5.34,
    y1: 198.57,
    x2: 245.89,
    y2: 198.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1",
    cx: 154.27,
    cy: 215.12,
    r: 92.34,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "New_Gradient_Swatch_copy",
    cx: 1064.45,
    cy: -1766.4,
    r: 34.39,
    gradientTransform: "matrix(1, 0, 0, 0.59, -981.52, 1202.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#230a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#040103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1146.07,
    y1: 123.95,
    x2: -1258.22,
    y2: 39.18,
    gradientTransform: "matrix(0.87, 0.5, -1.5, 0.29, 1303.13, 764.66)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12054e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 107.09,
    y1: 142.03,
    x2: 169.92,
    y2: 240.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a17bba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#a883c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b490cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c5a3dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#dbbbf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6b6f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#b595dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9d7dcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8e6ec6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 111.1,
    y1: 185.48,
    x2: 114.7,
    y2: 191.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 114.22,
    y1: 177.94,
    x2: 117.87,
    y2: 183.65,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 119.6,
    y1: 190.39,
    x2: 123.2,
    y2: 196.04,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 136.6,
    y1: 200.2,
    x2: 140.21,
    y2: 205.86,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 128.1,
    y1: 195.29,
    x2: 131.71,
    y2: 200.95,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 148.23,
    y1: 197.57,
    x2: 151.87,
    y2: 203.29,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 131.23,
    y1: 187.75,
    x2: 134.87,
    y2: 193.47,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 122.73,
    y1: 182.85,
    x2: 126.37,
    y2: 188.56,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 156.73,
    y1: 202.48,
    x2: 160.37,
    y2: 208.2,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 153.61,
    y1: 210.02,
    x2: 157.21,
    y2: 215.68,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 102.6,
    y1: 180.57,
    x2: 106.2,
    y2: 186.23,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 165.23,
    y1: 207.39,
    x2: 168.88,
    y2: 213.1,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 110.04,
    y1: 166.46,
    x2: 113.65,
    y2: 172.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 139.73,
    y1: 192.66,
    x2: 143.37,
    y2: 198.38,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 145.1,
    y1: 205.11,
    x2: 148.71,
    y2: 210.77,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 169.52,
    y1: 200.77,
    x2: 173.17,
    y2: 206.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 152.52,
    y1: 190.95,
    x2: 156.16,
    y2: 196.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 148.14,
    y1: 179.37,
    x2: 151.76,
    y2: 185.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 139.64,
    y1: 174.46,
    x2: 143.25,
    y2: 180.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 165.15,
    y1: 189.18,
    x2: 168.76,
    y2: 194.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 156.65,
    y1: 184.27,
    x2: 160.26,
    y2: 189.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 131.14,
    y1: 169.55,
    x2: 134.75,
    y2: 175.22,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 122.64,
    y1: 164.64,
    x2: 126.25,
    y2: 170.31,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 105.64,
    y1: 154.83,
    x2: 109.25,
    y2: 160.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 114.14,
    y1: 159.73,
    x2: 117.75,
    y2: 165.4,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 127.04,
    y1: 176.27,
    x2: 130.65,
    y2: 181.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 135.52,
    y1: 181.14,
    x2: 139.16,
    y2: 186.86,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 161.02,
    y1: 195.86,
    x2: 164.66,
    y2: 201.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 144.02,
    y1: 186.05,
    x2: 147.66,
    y2: 191.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 173.65,
    y1: 194.09,
    x2: 177.26,
    y2: 199.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 178.02,
    y1: 205.68,
    x2: 181.67,
    y2: 211.4,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 182.15,
    y1: 199,
    x2: 185.76,
    y2: 204.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 118.54,
    y1: 171.37,
    x2: 122.15,
    y2: 177.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 162.11,
    y1: 214.93,
    x2: 165.71,
    y2: 220.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 105.72,
    y1: 173.03,
    x2: 109.37,
    y2: 178.75,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 66.32,
    y1: 167.7,
    x2: 71.99,
    y2: 176.6,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 77.73,
    y1: 175.31,
    x2: 81.34,
    y2: 180.96,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 76.12,
    y1: 161.97,
    x2: 86.45,
    y2: 178.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 106.34,
    y1: 178.04,
    x2: 137.91,
    y2: 227.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 86.23,
    y1: 180.21,
    x2: 89.84,
    y2: 185.87,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 83.04,
    y1: 157.94,
    x2: 90.71,
    y2: 169.99,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 97.14,
    y1: 149.92,
    x2: 100.75,
    y2: 155.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 90.12,
    y1: 153.94,
    x2: 95.8,
    y2: 162.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 195.2,
    y1: 215.6,
    x2: 198.85,
    y2: 221.32,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 104.2,
    y1: 145.84,
    x2: 109.82,
    y2: 154.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 183.39,
    y1: 216.5,
    x2: 189.83,
    y2: 226.6,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 200.19,
    y1: 208.39,
    x2: 205.87,
    y2: 217.31,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 154.24,
    y1: 219.48,
    x2: 157.85,
    y2: 225.14,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 209.3,
    y1: 207.54,
    x2: 212.86,
    y2: 213.13,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 162.75,
    y1: 224.39,
    x2: 166.35,
    y2: 230.04,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 171.42,
    y1: 229.4,
    x2: 175.03,
    y2: 235.05,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 179.3,
    y1: 224.85,
    x2: 182.9,
    y2: 230.51,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 175.12,
    y1: 187.8,
    x2: 178.68,
    y2: 193.39,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 186.52,
    y1: 210.59,
    x2: 190.17,
    y2: 216.31,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 190.65,
    y1: 203.91,
    x2: 194.26,
    y2: 209.57,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 200.62,
    y1: 202.53,
    x2: 204.19,
    y2: 208.12,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 173.73,
    y1: 212.29,
    x2: 177.38,
    y2: 218.01,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 97.22,
    y1: 168.12,
    x2: 100.87,
    y2: 173.84,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 170.61,
    y1: 219.84,
    x2: 174.21,
    y2: 225.49,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 115.61,
    y1: 153.45,
    x2: 119.17,
    y2: 159.03,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 94.1,
    y1: 175.66,
    x2: 97.7,
    y2: 181.32,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 192.12,
    y1: 197.62,
    x2: 195.68,
    y2: 203.21,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 149.62,
    y1: 173.08,
    x2: 153.18,
    y2: 178.67,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 132.61,
    y1: 163.26,
    x2: 136.17,
    y2: 168.85,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 141.12,
    y1: 168.17,
    x2: 144.68,
    y2: 173.76,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 124.11,
    y1: 158.35,
    x2: 127.67,
    y2: 163.94,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 158.12,
    y1: 177.99,
    x2: 161.68,
    y2: 183.58,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 101.54,
    y1: 161.55,
    x2: 105.15,
    y2: 167.22,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 166.62,
    y1: 182.9,
    x2: 170.18,
    y2: 188.48,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 183.62,
    y1: 192.71,
    x2: 187.18,
    y2: 198.3,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 58.54,
    y1: 1.57,
    x2: 256.21,
    y2: 175.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1222.62,
    y1: 199.1,
    x2: 1100.49,
    y2: 9.76,
    gradientTransform: "translate(-985.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a0c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4299a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1270.35,
    y1: 213.9,
    x2: 1144.53,
    y2: 12.85,
    gradientTransform: "translate(-985.58)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-2",
    cx: 1234.45,
    cy: 90.38,
    r: 21.38,
    gradientTransform: "translate(-985.58)",
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -195.5,
    cy: 6757.34,
    r: 10.03,
    gradientTransform: "matrix(0, 1, -0.66, 0, 4736.17, 282.55)",
    xlinkHref: "#New_Gradient_Swatch_copy"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 107.14,
    y1: 143.44,
    x2: 169.91,
    y2: 241.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26",
    x1: 239.83,
    y1: 183.56,
    x2: 100.83,
    y2: -13.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6e41d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#4c9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-2",
    x1: 213.72,
    y1: 201.99,
    x2: 74.72,
    y2: 4.99,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-3",
    x1: 256.42,
    y1: 171.86,
    x2: 117.42,
    y2: -25.14,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-4",
    x1: 209.43,
    y1: 205.01,
    x2: 70.43,
    y2: 8.01,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8",
    x1: 239.55,
    y1: 183.77,
    x2: 100.55,
    y2: -13.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ffb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee1a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-3",
    cx: 181.03,
    cy: 100.23,
    r: 19.88,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-4",
    cx: 115.37,
    cy: 62.6,
    r: 19.88,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-5",
    cx: 150.6,
    cy: 21.01,
    r: 17.89,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-6",
    cx: 148.98,
    cy: 118.45,
    r: 17.89,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Radial_Gradient_1-7",
    cx: 149.44,
    cy: 53.78,
    r: 16.5,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#701ab5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#4e127f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#320c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1c072e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0d0315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#030105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 159.15,
    cy: 60.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 137.49,
    cy: 51.23,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 111.32,
    cy: 52.23,
    r: 82.84,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 85.15,
    cy: 21.06,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 84.99,
    cy: 23.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 80.32,
    cy: 18.89,
    r: 155.61,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 137.32,
    cy: 46.06,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 141.65,
    cy: 63.23,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 137.15,
    cy: 48.39,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 141.65,
    cy: 63.23,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 141.65,
    cy: 63.23,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 141.65,
    cy: 63.23,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 141.65,
    cy: 63.23,
    r: 106.76,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 127.77,
    cy: 38.59,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-61",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-62",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-63",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-64",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-66",
    cx: 151.77,
    cy: 61.09,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-67",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-68",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-69",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-70",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-71",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-73",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-74",
    cx: 167.94,
    cy: 70.92,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-75",
    cx: 156.44,
    cy: 73.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-76",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-77",
    cx: 134.94,
    cy: 59.76,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-78",
    cx: 134.94,
    cy: 59.75,
    r: 153.74,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 33.12,
    y1: -22.92,
    x2: 114.85,
    y2: 132.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 32.4,
    y1: -22.34,
    x2: 113.98,
    y2: 133.2,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 31.69,
    y1: -21.76,
    x2: 113.11,
    y2: 133.48,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 30.98,
    y1: -21.19,
    x2: 112.24,
    y2: 133.77,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 30.26,
    y1: -20.62,
    x2: 111.39,
    y2: 134.07,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 29.55,
    y1: -20.06,
    x2: 110.54,
    y2: 134.37,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 28.83,
    y1: -19.5,
    x2: 109.69,
    y2: 134.68,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 28.11,
    y1: -18.95,
    x2: 108.85,
    y2: 135.01,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 27.39,
    y1: -18.41,
    x2: 108.02,
    y2: 135.34,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 26.67,
    y1: -17.88,
    x2: 107.2,
    y2: 135.69,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 25.94,
    y1: -17.35,
    x2: 106.39,
    y2: 136.05,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 25.22,
    y1: -16.84,
    x2: 105.59,
    y2: 136.42,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-5",
    x1: 126.99,
    y1: 184.39,
    x2: -1.4,
    y2: -66.44,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-79",
    cx: 86.52,
    cy: 57.77,
    r: 69.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6c1e52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5c1946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#431233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#200918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 90.58,
    y1: 67.44,
    x2: 94.99,
    y2: 67.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 86.38,
    y1: 83.89,
    x2: 93.64,
    y2: 83.89,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9",
    x1: 85.14,
    y1: 70.03,
    x2: 93.25,
    y2: 70.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae25b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d744bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 84.73,
    y1: 77.45,
    x2: 88.85,
    y2: 77.45,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 71.8,
    y1: 75.42,
    x2: 78.5,
    y2: 75.42,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 91,
    y1: 80.73,
    x2: 93.86,
    y2: 80.73,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-2",
    x1: 88.49,
    y1: 75.04,
    x2: 91.9,
    y2: 75.04,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 97.15,
    y1: 70.5,
    x2: 99,
    y2: 70.5,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 79.4,
    y1: 70.87,
    x2: 86.34,
    y2: 70.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 95.4,
    y1: 75.69,
    x2: 102.74,
    y2: 75.69,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-2",
    x1: 73.89,
    y1: 72.59,
    x2: 82.61,
    y2: 72.59,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-3",
    x1: 75.99,
    y1: 59.76,
    x2: 82.81,
    y2: 59.76,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 84.96,
    y1: 63.93,
    x2: 88.43,
    y2: 63.93,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-4",
    x1: 80.65,
    y1: 79.55,
    x2: 84.25,
    y2: 79.55,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 100.83,
    y1: 88.32,
    x2: 110.13,
    y2: 88.32,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 66.35,
    y1: 71.36,
    x2: 69.64,
    y2: 71.36,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-3",
    x1: 59.62,
    y1: 52.92,
    x2: 74.25,
    y2: 52.92,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 102.98,
    y1: 83.37,
    x2: 106.42,
    y2: 83.37,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 104.9,
    y1: 81.87,
    x2: 114.56,
    y2: 81.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-5",
    x1: 94.05,
    y1: 79.19,
    x2: 100.86,
    y2: 79.19,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 101.16,
    y1: 74.48,
    x2: 108.87,
    y2: 74.48,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 66.35,
    y1: 67.44,
    x2: 71.74,
    y2: 67.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 96.01,
    y1: 83.61,
    x2: 98.7,
    y2: 83.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-6",
    x1: 66.35,
    y1: 64.56,
    x2: 77.24,
    y2: 64.56,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 95.64,
    y1: 93.13,
    x2: 101.49,
    y2: 93.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-4",
    x1: 66.35,
    y1: 61.74,
    x2: 82.99,
    y2: 61.74,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 90.58,
    y1: 133.72,
    x2: 94.99,
    y2: 133.72,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 86.38,
    y1: 150.17,
    x2: 93.64,
    y2: 150.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-5",
    x1: 85.14,
    y1: 136.31,
    x2: 93.25,
    y2: 136.31,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 84.73,
    y1: 143.72,
    x2: 88.85,
    y2: 143.72,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 71.8,
    y1: 141.7,
    x2: 78.5,
    y2: 141.7,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 91,
    y1: 147.01,
    x2: 93.86,
    y2: 147.01,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-7",
    x1: 88.49,
    y1: 141.32,
    x2: 91.9,
    y2: 141.32,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 97.15,
    y1: 136.77,
    x2: 99,
    y2: 136.77,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 79.4,
    y1: 137.14,
    x2: 86.34,
    y2: 137.14,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 95.4,
    y1: 141.96,
    x2: 102.74,
    y2: 141.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-6",
    x1: 73.89,
    y1: 138.87,
    x2: 82.61,
    y2: 138.87,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 75.99,
    y1: 126.03,
    x2: 82.81,
    y2: 126.03,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 84.96,
    y1: 130.21,
    x2: 88.43,
    y2: 130.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 80.65,
    y1: 145.83,
    x2: 84.25,
    y2: 145.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 100.83,
    y1: 154.59,
    x2: 110.13,
    y2: 154.59,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 66.35,
    y1: 137.64,
    x2: 69.64,
    y2: 137.64,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-7",
    x1: 59.62,
    y1: 119.19,
    x2: 74.25,
    y2: 119.19,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 102.98,
    y1: 149.65,
    x2: 106.42,
    y2: 149.65,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 104.9,
    y1: 148.14,
    x2: 114.56,
    y2: 148.14,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 94.05,
    y1: 145.47,
    x2: 100.86,
    y2: 145.47,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-8",
    x1: 101.16,
    y1: 140.75,
    x2: 108.87,
    y2: 140.75,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-9",
    x1: 66.35,
    y1: 133.72,
    x2: 71.74,
    y2: 133.72,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-10",
    x1: 96.01,
    y1: 149.88,
    x2: 98.7,
    y2: 149.88,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 66.35,
    y1: 130.84,
    x2: 77.24,
    y2: 130.84,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-11",
    x1: 66.35,
    y1: 128.02,
    x2: 82.99,
    y2: 128.02,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 86.38,
    y1: 101.69,
    x2: 93.64,
    y2: 101.69,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 85.14,
    y1: 87.83,
    x2: 93.25,
    y2: 87.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 84.73,
    y1: 95.24,
    x2: 88.85,
    y2: 95.24,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-12",
    x1: 71.8,
    y1: 93.22,
    x2: 78.5,
    y2: 93.22,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 91,
    y1: 98.53,
    x2: 93.86,
    y2: 98.53,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-13",
    x1: 88.49,
    y1: 92.84,
    x2: 91.9,
    y2: 92.84,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 79.4,
    y1: 88.66,
    x2: 86.34,
    y2: 88.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 73.89,
    y1: 90.39,
    x2: 82.61,
    y2: 90.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-14",
    x1: 80.65,
    y1: 97.35,
    x2: 84.25,
    y2: 97.35,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 100.83,
    y1: 106.11,
    x2: 110.13,
    y2: 106.11,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 66.35,
    y1: 89.16,
    x2: 69.64,
    y2: 89.16,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 102.98,
    y1: 101.17,
    x2: 106.42,
    y2: 101.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 94.05,
    y1: 96.99,
    x2: 100.86,
    y2: 96.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-15",
    x1: 66.35,
    y1: 85.24,
    x2: 71.74,
    y2: 85.24,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 96.01,
    y1: 101.4,
    x2: 98.7,
    y2: 101.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 66.35,
    y1: 82.36,
    x2: 77.24,
    y2: 82.36,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 83.55,
    y1: 103.28,
    x2: 86.96,
    y2: 103.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-8",
    x1: 74.46,
    y1: 99.1,
    x2: 81.4,
    y2: 99.1,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 98.05,
    y1: 111.61,
    x2: 101.49,
    y2: 111.61,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-16",
    x1: 89.12,
    y1: 107.43,
    x2: 95.92,
    y2: 107.43,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-9",
    x1: 61.42,
    y1: 92.8,
    x2: 72.31,
    y2: 92.8,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-17",
    x1: 66.35,
    y1: 79.54,
    x2: 82.99,
    y2: 79.54,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 86.38,
    y1: 123.74,
    x2: 93.64,
    y2: 123.74,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 85.14,
    y1: 109.88,
    x2: 93.25,
    y2: 109.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-18",
    x1: 84.73,
    y1: 117.29,
    x2: 88.85,
    y2: 117.29,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-19",
    x1: 71.8,
    y1: 115.27,
    x2: 78.5,
    y2: 115.27,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 91,
    y1: 120.58,
    x2: 93.86,
    y2: 120.58,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-10",
    x1: 88.49,
    y1: 114.89,
    x2: 91.9,
    y2: 114.89,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 79.4,
    y1: 110.71,
    x2: 86.34,
    y2: 110.71,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 73.89,
    y1: 112.44,
    x2: 82.61,
    y2: 112.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 80.65,
    y1: 119.4,
    x2: 84.25,
    y2: 119.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 100.83,
    y1: 128.16,
    x2: 110.13,
    y2: 128.16,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 66.35,
    y1: 111.21,
    x2: 69.64,
    y2: 111.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 102.98,
    y1: 123.22,
    x2: 106.42,
    y2: 123.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 94.05,
    y1: 119.04,
    x2: 100.86,
    y2: 119.04,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 66.35,
    y1: 107.29,
    x2: 71.74,
    y2: 107.29,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 96.01,
    y1: 123.45,
    x2: 98.7,
    y2: 123.45,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-20",
    x1: 66.35,
    y1: 104.41,
    x2: 77.24,
    y2: 104.41,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-21",
    x1: 83.55,
    y1: 125.33,
    x2: 86.96,
    y2: 125.33,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 74.46,
    y1: 121.15,
    x2: 81.4,
    y2: 121.15,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 98.05,
    y1: 133.66,
    x2: 101.49,
    y2: 133.66,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-22",
    x1: 89.12,
    y1: 129.48,
    x2: 95.92,
    y2: 129.48,
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 66.09,
    y1: 116.17,
    x2: 72.31,
    y2: 116.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 66.35,
    y1: 101.59,
    x2: 82.99,
    y2: 101.59,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 38.49,
    y: 175.29,
    width: 97.33,
    height: 106.33,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.49,
    y: 175.29,
    width: 97.33,
    height: 106.33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-6",
    x1: 124.61,
    y1: 207.66,
    x2: -68.77,
    y2: 301.37,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 90.58,
    y1: 2095.05,
    x2: 94.99,
    y2: 2095.05,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 86.38,
    y1: 2111.5,
    x2: 93.64,
    y2: 2111.5,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-11",
    x1: 85.14,
    y1: 2097.64,
    x2: 93.25,
    y2: 2097.64,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 84.73,
    y1: 2105.05,
    x2: 88.85,
    y2: 2105.05,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 71.8,
    y1: 2103.02,
    x2: 78.5,
    y2: 2103.02,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 91,
    y1: 2108.34,
    x2: 93.86,
    y2: 2108.34,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-23",
    x1: 88.49,
    y1: 2102.64,
    x2: 91.9,
    y2: 2102.64,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 97.15,
    y1: 2098.1,
    x2: 99,
    y2: 2098.1,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 79.4,
    y1: 2098.47,
    x2: 86.34,
    y2: 2098.47,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 95.4,
    y1: 2103.29,
    x2: 102.74,
    y2: 2103.29,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-12",
    x1: 73.89,
    y1: 2100.2,
    x2: 82.61,
    y2: 2100.2,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 75.99,
    y1: 2087.36,
    x2: 82.81,
    y2: 2087.36,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 84.96,
    y1: 2091.54,
    x2: 88.43,
    y2: 2091.54,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 80.65,
    y1: 2107.16,
    x2: 84.25,
    y2: 2107.16,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 100.83,
    y1: 2115.92,
    x2: 110.13,
    y2: 2115.92,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 66.35,
    y1: 2098.96,
    x2: 69.64,
    y2: 2098.96,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-13",
    x1: 59.62,
    y1: 2080.52,
    x2: 74.25,
    y2: 2080.52,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 102.98,
    y1: 2110.98,
    x2: 106.42,
    y2: 2110.98,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 104.9,
    y1: 2109.47,
    x2: 114.56,
    y2: 2109.47,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 94.05,
    y1: 2106.8,
    x2: 100.86,
    y2: 2106.8,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-24",
    x1: 101.16,
    y1: 2102.08,
    x2: 108.87,
    y2: 2102.08,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-25",
    x1: 66.35,
    y1: 2095.05,
    x2: 71.74,
    y2: 2095.05,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-26",
    x1: 96.01,
    y1: 2111.21,
    x2: 98.7,
    y2: 2111.21,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 66.35,
    y1: 2092.16,
    x2: 77.24,
    y2: 2092.16,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_9-27",
    x1: 66.35,
    y1: 2089.34,
    x2: 82.99,
    y2: 2089.34,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2216.25)",
    xlinkHref: "#New_Gradient_Swatch_copy_9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 166.52,
    y1: 50.01,
    x2: 244.88,
    y2: 199.44,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 166.4,
    y1: 51.37,
    x2: 243.83,
    y2: 199.01,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 166.29,
    y1: 52.73,
    x2: 242.79,
    y2: 198.59,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 166.18,
    y1: 54.08,
    x2: 241.74,
    y2: 198.16,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 166.08,
    y1: 55.44,
    x2: 240.7,
    y2: 197.73,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 165.97,
    y1: 56.79,
    x2: 239.66,
    y2: 197.31,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 165.87,
    y1: 58.14,
    x2: 238.63,
    y2: 196.88,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 165.77,
    y1: 59.49,
    x2: 237.6,
    y2: 196.45,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 165.67,
    y1: 60.84,
    x2: 236.57,
    y2: 196.02,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 165.58,
    y1: 62.18,
    x2: 235.54,
    y2: 195.58,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 165.49,
    y1: 63.53,
    x2: 234.51,
    y2: 195.15,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 165.4,
    y1: 64.87,
    x2: 233.49,
    y2: 194.72,
    xlinkHref: "#linear-gradient-81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7",
    x1: 295.53,
    y1: 236.08,
    x2: 147.06,
    y2: 104.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1fc3df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-80",
    cx: 216.15,
    cy: 155.84,
    r: 120.54,
    xlinkHref: "#radial-gradient-79"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-7",
    x1: 274.59,
    y1: 241.25,
    x2: 79.34,
    y2: 39,
    gradientTransform: "translate(103.73 -75.02) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-8",
    x1: 281.36,
    y1: 234.71,
    x2: 86.11,
    y2: 32.46,
    gradientTransform: "translate(117.18 -88.04) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-9",
    x1: 288.58,
    y1: 227.74,
    x2: 93.33,
    y2: 25.49,
    gradientTransform: "translate(130.34 -101.27) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-10",
    x1: 317.5,
    y1: 290.19,
    x2: -247.29,
    y2: -294.85,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-11",
    x1: 324.27,
    y1: 283.65,
    x2: -240.52,
    y2: -301.39,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-12",
    x1: 331.48,
    y1: 276.68,
    x2: -233.3,
    y2: -308.36,
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-14",
    x1: 270.26,
    y1: 214.75,
    x2: 31.26,
    y2: 4.41,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-15",
    x1: 247.46,
    y1: 212.26,
    x2: 152.71,
    y2: 118.51,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-16",
    x1: 249.23,
    y1: 210.48,
    x2: 154.48,
    y2: 116.73,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-17",
    x1: 253.58,
    y1: 206.08,
    x2: 158.83,
    y2: 112.33,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-18",
    x1: 255.07,
    y1: 204.57,
    x2: 160.32,
    y2: 110.82,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-19",
    x1: 260.65,
    y1: 198.93,
    x2: 165.9,
    y2: 105.18,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 5.34,
    y: 130.29,
    width: 280.56,
    height: 153.72,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.59,211.58,105.82,132A16,16,0,0,0,98,130.29a21.91,21.91,0,0,0-10.63,2.63L9.16,178.06c-2.39,1.39-3.82,3.09-3.82,4.55s1.44,2.45,2.3,2.94l137.77,79.54a16,16,0,0,0,7.84,1.75,21.8,21.8,0,0,0,10.63-2.63l78.19-45.14c2.39-1.38,3.82-3.08,3.82-4.55S244.45,212.08,243.59,211.58Zm-24.33,2-42,24.25c-2.58,1.5-6.5,1.66-8.74.37L56.64,173.59c-2.24-1.3-2-3.56.63-5.05l42-24.25c2.59-1.49,6.5-1.66,8.74-.36l111.87,64.59C222.12,209.81,221.84,212.07,219.26,213.56Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_7-2",
    x1: 295.53,
    y1: 297.08,
    x2: 147.06,
    y2: 165.58,
    xlinkHref: "#New_Gradient_Swatch_copy_7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_26-13",
    x1: 281.36,
    y1: 295.71,
    x2: 86.11,
    y2: 93.46,
    gradientTransform: "translate(147.97 -79.7) rotate(30.31)",
    xlinkHref: "#New_Gradient_Swatch_copy_26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-20",
    x1: 253.58,
    y1: 2226.84,
    x2: 158.83,
    y2: 2133.09,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2170.49)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-21",
    x1: 255.07,
    y1: 2225.33,
    x2: 160.32,
    y2: 2131.58,
    gradientTransform: "matrix(1, 1.16, 0, -1, 0, 2170.49)",
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-22",
    x1: 118.2,
    y1: 115.47,
    x2: 48.54,
    y2: 30.47,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-23",
    x1: 85.71,
    y1: 142.1,
    x2: 16.04,
    y2: 57.1,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_8-24",
    x1: 98.61,
    y1: 131.53,
    x2: 28.94,
    y2: 46.53,
    xlinkHref: "#New_Gradient_Swatch_copy_8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144,274.17,6.26,194.63c-2.42-1.4-3.63-3.26-3.67-5.22v-6.83c.05-2.38,1.81,1.76,5.2-.2L86,137.24c6.29-3.63,15.79-4,21.23-.88L245,215.9c1.81,1,3.13-3.4,3.6-2,.16.47.06,6.72.07,7.21.05,2.44-1.71,5-5.2,7l-78.18,45.14C159,276.92,149.47,277.31,144,274.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M144,267.47,6.26,187.94c-5.44-3.15-4.75-8.63,1.53-12.26L86,130.54c6.29-3.63,15.79-4,21.23-.88L245,209.2c5.44,3.14,4.75,8.63-1.53,12.25l-78.18,45.14C159,270.22,149.47,270.62,144,267.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M248.63,223.19c0,2.41-1.75,4.95-5.19,6.93l-78.18,45.14c-6.29,3.63-15.79,4-21.23.88L6.26,196.6c-2.63-1.52-3.81-3.58-3.64-5.72,0,.1,0,.22,0,.37v6.83c0,2,1.25,3.82,3.67,5.22L144,282.84c5.44,3.14,14.94,2.75,21.23-.88l78.18-45.14c3.49-2,5.25-4.6,5.2-7C248.63,229.37,248.7,224.87,248.63,223.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M153.25,266.84a16,16,0,0,1-7.84-1.75L7.64,185.55c-.86-.49-2.3-1.53-2.3-2.94s1.43-3.16,3.82-4.55l78.19-45.14A21.91,21.91,0,0,1,98,130.29a16,16,0,0,1,7.84,1.75l137.77,79.54c.86.5,2.3,1.54,2.3,2.94s-1.43,3.17-3.82,4.55l-78.19,45.14A21.8,21.8,0,0,1,153.25,266.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.44,220.32l-78.18,45.14c-6.29,3.62-15.79,4-21.23.88L6.26,186.8c-2.25-1.31-3.44-3-3.63-4.82-.28,2.22.91,4.38,3.63,6L144,267.47c5.44,3.15,14.94,2.75,21.23-.88l78.18-45.14c3.68-2.12,5.42-4.87,5.16-7.43C248.32,216.24,246.58,218.51,243.44,220.32Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 82.87,
    cy: 159.15,
    rx: 34.39,
    ry: 20.31,
    transform: "translate(-47.26 35.61) rotate(-18.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M168.51,238.18,56.64,173.59c-2.24-1.3-2-3.56.63-5.05l42-24.25c2.59-1.49,6.5-1.66,8.74-.36l111.87,64.59c2.24,1.29,2,3.55-.62,5l-42,24.25C174.67,239.31,170.75,239.47,168.51,238.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.72,149l7.17,4.14a3.63,3.63,0,0,0,3.29,0c.91-.52.9-1.37,0-1.9L105,147.12a3.63,3.63,0,0,0-3.29,0C100.8,147.63,100.81,148.48,101.72,149ZM114,156.1l3.4,2a3.63,3.63,0,0,0,3.29,0c.91-.52.9-1.37,0-1.9l-3.4-2a3.63,3.63,0,0,0-3.29,0A1,1,0,0,0,114,156.1Zm8.51,4.9,3.39,2a3.63,3.63,0,0,0,3.29,0c.91-.52.9-1.37,0-1.9l-3.39-2a3.65,3.65,0,0,0-3.3,0A1,1,0,0,0,122.5,161Zm8.5,4.91,3.39,2a3.63,3.63,0,0,0,3.29,0c.91-.52.9-1.37,0-1.9l-3.39-2a3.63,3.63,0,0,0-3.29,0A1,1,0,0,0,131,165.91Zm8.5,4.91,3.39,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.39-2a3.63,3.63,0,0,0-3.29,0C138.58,169.44,138.59,170.29,139.5,170.82Zm8.5,4.91,3.39,2a3.65,3.65,0,0,0,3.3,0,1,1,0,0,0,0-1.9l-3.4-2a3.66,3.66,0,0,0-3.29,0C147.08,174.35,147.09,175.2,148,175.73Zm8.5,4.91,3.4,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.4-2a3.63,3.63,0,0,0-3.29,0C155.58,179.26,155.59,180.11,156.5,180.64Zm8.5,4.91,3.4,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.4-2a3.6,3.6,0,0,0-3.29,0A1,1,0,0,0,165,185.55Zm8.5,4.9,3.4,2a3.63,3.63,0,0,0,3.29,0c.91-.52.9-1.37,0-1.9l-3.4-2a3.63,3.63,0,0,0-3.29,0A1,1,0,0,0,173.5,190.45Zm8.5,4.91,3.4,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.39-2a3.65,3.65,0,0,0-3.3,0A1,1,0,0,0,182,195.36Zm8.51,4.91,3.39,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.39-2a3.63,3.63,0,0,0-3.29,0C189.59,198.89,189.59,199.74,190.51,200.27Zm8.5,4.91,3.39,2a3.6,3.6,0,0,0,3.29,0c.91-.52.91-1.37,0-1.9l-3.39-2a3.66,3.66,0,0,0-3.29,0C198.09,203.8,198.1,204.65,199,205.18Zm8.68,5,3.39,2a3.63,3.63,0,0,0,3.29,0,1,1,0,0,0,0-1.9l-3.39-2a3.69,3.69,0,0,0-3.3,0C206.77,208.81,206.77,209.66,207.69,210.19ZM94.07,153.69,97,155.38a4.13,4.13,0,0,0,3.75,0l2.92-1.69a1.14,1.14,0,0,0,0-2.16l-2.94-1.7a4.16,4.16,0,0,0-3.75,0l-2.92,1.68A1.15,1.15,0,0,0,94.07,153.69Zm15.19,6.61,2.92-1.69a1.14,1.14,0,0,0,0-2.16l-2.94-1.7a4.13,4.13,0,0,0-3.75,0l-2.92,1.68a1.15,1.15,0,0,0,0,2.17l2.94,1.69A4.16,4.16,0,0,0,109.26,160.3Zm1.82,3.2,2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69a1.14,1.14,0,0,0,0-2.16l-2.94-1.7a4.14,4.14,0,0,0-3.74,0l-2.93,1.69C110,161.94,110,162.9,111.08,163.5Zm8.5,4.91,2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c1-.6,1-1.56,0-2.16l-2.94-1.7a4.14,4.14,0,0,0-3.74,0l-2.92,1.69C118.53,166.84,118.54,167.81,119.58,168.41Zm18.09,2.76-2.94-1.69a4.14,4.14,0,0,0-3.74,0l-2.92,1.69a1.14,1.14,0,0,0,0,2.16L131,175a4.11,4.11,0,0,0,3.74,0l2.93-1.68C138.72,172.74,138.71,171.77,137.67,171.17Zm8.51,4.91-2.94-1.69a4.13,4.13,0,0,0-3.75,0l-2.92,1.69a1.14,1.14,0,0,0,0,2.16l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.68A1.15,1.15,0,0,0,146.18,176.08Zm8.5,4.91-2.94-1.7a4.13,4.13,0,0,0-3.75,0L145.07,181a1.15,1.15,0,0,0,0,2.17l2.94,1.69a4.13,4.13,0,0,0,3.75,0l2.92-1.69C155.72,182.56,155.71,181.59,154.68,181Zm8.5,4.91-2.94-1.7a4.13,4.13,0,0,0-3.75,0l-2.92,1.68a1.14,1.14,0,0,0,0,2.16l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69A1.14,1.14,0,0,0,163.18,185.9Zm8.5,4.91-2.94-1.7a4.16,4.16,0,0,0-3.75,0l-2.92,1.69a1.14,1.14,0,0,0,0,2.16l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69A1.14,1.14,0,0,0,171.68,190.81Zm8.5,4.91-2.94-1.7a4.16,4.16,0,0,0-3.75,0l-2.92,1.69c-1,.59-1,1.56,0,2.16l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69A1.14,1.14,0,0,0,180.18,195.72Zm-1.09,7.05,2.94,1.7a4.11,4.11,0,0,0,3.74,0l2.92-1.68a1.15,1.15,0,0,0,0-2.17l-2.94-1.69a4.11,4.11,0,0,0-3.74,0l-2.93,1.69C178,201.2,178.05,202.17,179.09,202.77Zm18.09,2.76-2.94-1.69a4.11,4.11,0,0,0-3.74,0l-2.92,1.69c-1,.59-1,1.56,0,2.16l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.68A1.14,1.14,0,0,0,197.18,205.53Zm12.45,7.19-6.71-3.87a4.11,4.11,0,0,0-3.74,0l-2.93,1.69c-1,.59-1,1.56,0,2.16l6.71,3.87a4.11,4.11,0,0,0,3.74,0l2.93-1.69C210.68,214.29,210.67,213.32,209.63,212.72ZM86.2,158.23l6.71,3.88a4.16,4.16,0,0,0,3.75,0l2.92-1.69a1.14,1.14,0,0,0,0-2.16l-6.72-3.88a4.14,4.14,0,0,0-3.74,0l-2.92,1.69A1.14,1.14,0,0,0,86.2,158.23Zm12.27,7.09,2.94,1.7a4.13,4.13,0,0,0,3.75,0l2.92-1.68a1.15,1.15,0,0,0,0-2.17l-2.94-1.69a4.16,4.16,0,0,0-3.75,0l-2.92,1.69C97.43,163.75,97.44,164.72,98.47,165.32Zm11.44,6.61a4.16,4.16,0,0,0,3.75,0l2.92-1.68a1.15,1.15,0,0,0,0-2.17l-2.94-1.69a4.13,4.13,0,0,0-3.75,0L107,168.07c-1,.59-1,1.56,0,2.16Zm8.51,4.9a4.11,4.11,0,0,0,3.74,0l2.92-1.69a1.14,1.14,0,0,0,0-2.16l-2.94-1.7a4.11,4.11,0,0,0-3.74,0L115.46,173c-1,.6-1,1.57,0,2.17Zm8.47-.63L124,177.88a1.14,1.14,0,0,0,0,2.16l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c1-.59,1-1.56,0-2.16l-2.94-1.7A4.11,4.11,0,0,0,126.89,176.2Zm8.68,4.8-3.28,1.89a1,1,0,0,0,0,2l3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.29-1.89a1,1,0,0,0,0-2L139,181A3.7,3.7,0,0,0,135.57,181Zm8.5,4.91-3.28,1.89a1,1,0,0,0,0,2l3.3,1.9a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.93-.53.92-1.41,0-2l-3.31-1.91A3.73,3.73,0,0,0,144.07,185.91Zm8.5,4.91-3.28,1.89a1,1,0,0,0,0,1.95l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.9a1,1,0,0,0,0-2l-3.3-1.91A3.75,3.75,0,0,0,152.57,190.82Zm8.5,4.9-3.28,1.9a1,1,0,0,0,0,1.95l3.3,1.91a3.78,3.78,0,0,0,3.39,0l3.28-1.9a1,1,0,0,0,0-2l-3.3-1.91A3.78,3.78,0,0,0,161.07,195.72Zm8.5,4.91-3.28,1.9c-.93.53-.92,1.41,0,1.95l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.93-.54.93-1.41,0-2l-3.3-1.9A3.75,3.75,0,0,0,169.57,200.63Zm11.92,10.67,3.28-1.89a1,1,0,0,0,0-2l-3.3-1.9a3.75,3.75,0,0,0-3.39,0l-3.28,1.9c-.93.53-.92,1.41,0,1.95l3.31,1.91A3.73,3.73,0,0,0,181.49,211.3Zm8.5,4.91,3.28-1.89a1,1,0,0,0,0-2l-3.3-1.9a3.7,3.7,0,0,0-3.38,0l-3.28,1.89a1,1,0,0,0,0,2l3.3,1.9A3.7,3.7,0,0,0,190,216.21Zm11.95,1.16-3.3-1.9a3.72,3.72,0,0,0-3.39,0L192,217.35a1,1,0,0,0,0,2l3.31,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89A1,1,0,0,0,201.94,217.37Zm-123.8-54.7,10.66,6.16a3.78,3.78,0,0,0,3.39,0l3.28-1.9a1,1,0,0,0,0-1.95L84.8,158.83a3.75,3.75,0,0,0-3.39,0l-3.28,1.89A1,1,0,0,0,78.14,162.67ZM94,171.83l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.93-.54.93-1.41,0-2l-3.3-1.9a3.75,3.75,0,0,0-3.39,0L94,169.88C93.06,170.41,93.07,171.29,94,171.83Zm8.5,4.91,3.31,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89a1,1,0,0,0,0-2l-3.3-1.9a3.75,3.75,0,0,0-3.39,0l-3.28,1.89A1,1,0,0,0,102.5,176.74Zm8.51,4.91,3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89a1,1,0,0,0,0-2l-3.3-1.91a3.73,3.73,0,0,0-3.38,0L111,179.69A1,1,0,0,0,111,181.65Zm15.18,6.82,3.28-1.9c.94-.53.93-1.41,0-1.95l-3.3-1.91a3.73,3.73,0,0,0-3.38,0l-3.28,1.89c-.94.54-.93,1.41,0,2l3.3,1.9A3.73,3.73,0,0,0,126.19,188.47Zm8.51,4.91,3.28-1.9a1,1,0,0,0,0-1.95l-3.31-1.91a3.73,3.73,0,0,0-3.38,0L128,189.51a1,1,0,0,0,0,2l3.3,1.91A3.78,3.78,0,0,0,134.7,193.38Zm8.5,4.9,3.28-1.89a1,1,0,0,0,0-1.95l-3.3-1.91a3.78,3.78,0,0,0-3.39,0l-3.28,1.9a1,1,0,0,0,0,2l3.3,1.91A3.75,3.75,0,0,0,143.2,198.28Zm8.5,4.91L155,201.3c.93-.54.93-1.41,0-2l-3.3-1.9a3.75,3.75,0,0,0-3.39,0l-3.28,1.9a1,1,0,0,0,0,1.95l3.3,1.91A3.75,3.75,0,0,0,151.7,203.19Zm8.5,4.91,3.28-1.89a1,1,0,0,0,0-2l-3.3-1.9a3.72,3.72,0,0,0-3.39,0l-3.28,1.89a1,1,0,0,0,0,2l3.3,1.9A3.72,3.72,0,0,0,160.2,208.1Zm8.5,4.91,3.28-1.9a1,1,0,0,0,0-2l-3.3-1.91a3.75,3.75,0,0,0-3.39,0L162,209.14a1,1,0,0,0,0,2l3.31,1.9A3.73,3.73,0,0,0,168.7,213Zm1.82,3,3.3,1.9a3.73,3.73,0,0,0,3.38,0l3.28-1.9a1,1,0,0,0,0-2l-3.3-1.91a3.73,3.73,0,0,0-3.38,0l-3.29,1.89C169.57,214.59,169.58,215.46,170.52,216Zm23.55,5.91-8.4-4.85a3.76,3.76,0,0,0-3.38,0L179,219c-.94.54-.93,1.41,0,1.95l8.39,4.85a3.78,3.78,0,0,0,3.39,0l3.28-1.9A1,1,0,0,0,194.07,221.92ZM70.3,167.46l15.13,8.73a4.25,4.25,0,0,0,3.82,0l2.84-1.65c1.06-.6,1-1.59,0-2.2L77,163.61a4.24,4.24,0,0,0-3.83,0l-2.84,1.64C69.24,165.86,69.24,166.84,70.3,167.46Zm20.77,12,2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.85-1.64c1.05-.61,1-1.59,0-2.21l-2.86-1.65a4.25,4.25,0,0,0-3.82,0l-2.85,1.65C90,177.84,90,178.83,91.07,179.44Zm8.5,4.91,2.86,1.65a4.19,4.19,0,0,0,3.82,0l2.85-1.64a1.17,1.17,0,0,0,0-2.21l-2.86-1.65a4.25,4.25,0,0,0-3.82,0l-2.84,1.64A1.17,1.17,0,0,0,99.57,184.35Zm8.5,4.91,2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64a1.17,1.17,0,0,0,0-2.21l-2.87-1.65a4.22,4.22,0,0,0-3.82,0l-2.84,1.64A1.17,1.17,0,0,0,108.07,189.26Zm8.5,4.91,2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64a1.17,1.17,0,0,0,0-2.21l-2.86-1.65a4.24,4.24,0,0,0-3.83,0L116.56,192A1.17,1.17,0,0,0,116.57,194.17Zm8.5,4.91,2.86,1.65a4.27,4.27,0,0,0,3.83,0l2.84-1.65a1.16,1.16,0,0,0,0-2.2l-2.86-1.66a4.24,4.24,0,0,0-3.83,0l-2.84,1.64A1.17,1.17,0,0,0,125.07,199.08Zm8.5,4.91,2.86,1.65a4.24,4.24,0,0,0,3.83,0L143.1,204a1.16,1.16,0,0,0,0-2.2l-2.86-1.66a4.24,4.24,0,0,0-3.83,0l-2.84,1.64C132.51,202.39,132.51,203.37,133.57,204Zm8.5,4.9,2.87,1.66a4.22,4.22,0,0,0,3.82,0l2.84-1.64a1.17,1.17,0,0,0,0-2.21l-2.86-1.65a4.25,4.25,0,0,0-3.82,0l-2.85,1.65C141,207.29,141,208.28,142.07,208.89Zm8.51,4.91,2.86,1.65a4.19,4.19,0,0,0,3.82,0l2.84-1.64a1.17,1.17,0,0,0,0-2.21L157.23,210a4.22,4.22,0,0,0-3.82,0l-2.85,1.64A1.17,1.17,0,0,0,150.58,213.8Zm8.5,4.91,2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64a1.17,1.17,0,0,0,0-2.21l-2.86-1.65a4.22,4.22,0,0,0-3.82,0l-2.84,1.64A1.17,1.17,0,0,0,159.08,218.71Zm8.5,4.91,2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64a1.17,1.17,0,0,0,0-2.21l-2.87-1.65a4.19,4.19,0,0,0-3.82,0l-2.84,1.64A1.17,1.17,0,0,0,167.58,223.62Zm18.21,2.83-2.87-1.66a4.22,4.22,0,0,0-3.82,0l-2.84,1.64c-1.06.61-1,1.59,0,2.21l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64C186.85,228.05,186.84,227.06,185.79,226.45ZM75.72,172l-6.64-3.83a4.25,4.25,0,0,0-3.82,0l-2.84,1.64a1.17,1.17,0,0,0,0,2.21l6.63,3.83a4.24,4.24,0,0,0,3.83,0l2.84-1.64A1.17,1.17,0,0,0,75.72,172Zm8.5,4.91-2.86-1.65a4.21,4.21,0,0,0-3.83,0l-2.84,1.64a1.17,1.17,0,0,0,0,2.21l2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64A1.17,1.17,0,0,0,84.22,176.9Zm8.5,4.91-2.86-1.66a4.22,4.22,0,0,0-3.82,0l-2.85,1.64a1.17,1.17,0,0,0,0,2.21l2.87,1.65a4.25,4.25,0,0,0,3.82,0L92.73,184C93.79,183.41,93.78,182.42,92.72,181.81Zm59.51,34.35-53.87-31.1a4.22,4.22,0,0,0-3.82,0l-2.85,1.64c-1,.61-1,1.59,0,2.21L145.58,220a4.22,4.22,0,0,0,3.82,0l2.84-1.64C153.3,217.76,153.29,216.78,152.23,216.16Zm8.5,4.91-2.86-1.65a4.25,4.25,0,0,0-3.82,0l-2.85,1.65c-1,.6-1,1.59,0,2.2l2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.84-1.64A1.17,1.17,0,0,0,160.73,221.07Zm8.5,4.91-2.86-1.65a4.22,4.22,0,0,0-3.82,0L159.7,226a1.17,1.17,0,0,0,0,2.21l2.86,1.65a4.19,4.19,0,0,0,3.82,0l2.85-1.64A1.17,1.17,0,0,0,169.23,226Zm8.68,5-2.86-1.65a4.22,4.22,0,0,0-3.82,0L168.38,231a1.17,1.17,0,0,0,0,2.21l2.87,1.65a4.19,4.19,0,0,0,3.82,0l2.84-1.64A1.17,1.17,0,0,0,177.91,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M108.07,189.26l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.66-.38.9-.92.73-1.41a1.54,1.54,0,0,1-.73.78l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.59,1.59,0,0,1-.74-.8C107.15,188.34,107.4,188.87,108.07,189.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M111,181.65l3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89c.61-.35.81-.84.63-1.29a1.41,1.41,0,0,1-.63.66l-3.28,1.89a3.73,3.73,0,0,1-3.38,0L111,181a1.4,1.4,0,0,1-.64-.67C110.19,180.8,110.4,181.3,111,181.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M116.57,194.17l2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64c.66-.39.9-.92.73-1.42a1.52,1.52,0,0,1-.73.79l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-2.86-1.66a1.54,1.54,0,0,1-.74-.79C115.66,193.24,115.9,193.78,116.57,194.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M133.57,204l2.86,1.65a4.24,4.24,0,0,0,3.83,0L143.1,204c.67-.38.91-.91.73-1.41a1.55,1.55,0,0,1-.73.79L140.26,205a4.24,4.24,0,0,1-3.83,0l-2.86-1.65a1.6,1.6,0,0,1-.74-.8C132.66,203.06,132.9,203.6,133.57,204Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M125.07,199.08l2.86,1.65a4.27,4.27,0,0,0,3.83,0l2.84-1.65c.66-.38.91-.91.73-1.41a1.52,1.52,0,0,1-.73.79l-2.84,1.64a4.21,4.21,0,0,1-3.83,0l-2.86-1.65a1.54,1.54,0,0,1-.74-.79C124.16,198.15,124.4,198.69,125.07,199.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M155.61,200a1.37,1.37,0,0,1-.63.66l-3.28,1.9a3.75,3.75,0,0,1-3.39,0l-3.3-1.9a1.5,1.5,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l3.3,1.91a3.75,3.75,0,0,0,3.39,0L155,201.3C155.58,201,155.79,200.46,155.61,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M138.6,190.2a1.38,1.38,0,0,1-.62.66l-3.28,1.89a3.75,3.75,0,0,1-3.39,0l-3.3-1.91a1.45,1.45,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l3.3,1.91a3.78,3.78,0,0,0,3.39,0l3.28-1.9C138.58,191.13,138.78,190.65,138.6,190.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M119.51,186.56l3.3,1.9a3.73,3.73,0,0,0,3.38,0l3.28-1.9c.61-.34.81-.83.63-1.28a1.41,1.41,0,0,1-.63.66l-3.28,1.89a3.73,3.73,0,0,1-3.38,0l-3.3-1.91a1.4,1.4,0,0,1-.64-.67C118.69,185.71,118.9,186.2,119.51,186.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M164.11,204.92a1.41,1.41,0,0,1-.63.66l-3.28,1.9a3.78,3.78,0,0,1-3.39,0l-3.3-1.91a1.4,1.4,0,0,1-.64-.67c-.18.45,0,1,.64,1.3l3.3,1.9a3.72,3.72,0,0,0,3.39,0l3.28-1.89C164.08,205.86,164.29,205.37,164.11,204.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M157.26,215.46l2.84-1.64c.67-.38.91-.92.73-1.41a1.5,1.5,0,0,1-.73.78l-2.84,1.65a4.25,4.25,0,0,1-3.82,0l-2.86-1.65a1.62,1.62,0,0,1-.75-.8c-.17.5.08,1,.75,1.42l2.86,1.65A4.19,4.19,0,0,0,157.26,215.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M99.57,184.35l2.86,1.65a4.19,4.19,0,0,0,3.82,0l2.85-1.64c.66-.38.9-.92.73-1.41a1.59,1.59,0,0,1-.73.78l-2.85,1.65a4.25,4.25,0,0,1-3.82,0l-2.86-1.65a1.59,1.59,0,0,1-.74-.8C98.65,183.43,98.9,184,99.57,184.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M172.61,209.83a1.41,1.41,0,0,1-.63.66l-3.28,1.89a3.73,3.73,0,0,1-3.38,0L162,210.47a1.33,1.33,0,0,1-.63-.67c-.18.45,0,.94.63,1.3l3.31,1.9a3.73,3.73,0,0,0,3.38,0l3.28-1.9C172.58,210.77,172.79,210.28,172.61,209.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M107,170.23l2.93,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.68c.65-.38.89-.91.71-1.39a1.5,1.5,0,0,1-.71.76l-2.92,1.69a4.16,4.16,0,0,1-3.75,0L107,169.6a1.52,1.52,0,0,1-.73-.77C106.08,169.32,106.32,169.85,107,170.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M147.1,195.11a1.38,1.38,0,0,1-.62.66l-3.28,1.89a3.75,3.75,0,0,1-3.39,0l-3.3-1.9a1.45,1.45,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89C147.08,196,147.28,195.55,147.1,195.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M142.07,208.89l2.87,1.66a4.22,4.22,0,0,0,3.82,0l2.84-1.64c.67-.38.91-.92.73-1.41a1.55,1.55,0,0,1-.73.79l-2.84,1.64a4.22,4.22,0,0,1-3.82,0l-2.87-1.65a1.64,1.64,0,0,1-.74-.8C141.16,208,141.4,208.51,142.07,208.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M176.9,203.21a1.32,1.32,0,0,1-.63.66l-3.28,1.9a3.75,3.75,0,0,1-3.39,0l-3.3-1.9a1.37,1.37,0,0,1-.63-.67c-.18.45,0,.94.63,1.29l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89C176.87,204.15,177.08,203.66,176.9,203.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M159.27,194.06,156,196a3.75,3.75,0,0,1-3.39,0L149.3,194a1.4,1.4,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.6-.35.81-.83.63-1.28A1.46,1.46,0,0,1,159.27,194.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M154.69,182.53l-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77c-.18.49.06,1,.72,1.4l2.94,1.69a4.13,4.13,0,0,0,3.75,0l2.92-1.69c.65-.37.89-.9.71-1.39A1.56,1.56,0,0,1,154.69,182.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M146.19,177.62l-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77c-.18.49.06,1,.72,1.4l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.68c.65-.38.88-.91.71-1.39A1.54,1.54,0,0,1,146.19,177.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M171.69,192.35,168.77,194a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.52,1.52,0,0,1-.72-.78c-.17.49.06,1,.72,1.4l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.65-.38.89-.9.71-1.39A1.51,1.51,0,0,1,171.69,192.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M163.19,187.44l-2.92,1.68a4.13,4.13,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77c-.18.48.06,1,.72,1.39l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.65-.37.89-.9.71-1.39A1.51,1.51,0,0,1,163.19,187.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M137.69,172.71l-2.93,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77c-.18.49.06,1,.72,1.4L131,175a4.11,4.11,0,0,0,3.74,0l2.93-1.68c.65-.38.88-.9.71-1.39A1.5,1.5,0,0,1,137.69,172.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M129.18,167.8l-2.92,1.69a4.11,4.11,0,0,1-3.74,0l-2.94-1.69a1.59,1.59,0,0,1-.73-.78c-.17.49.07,1,.73,1.4l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.66-.38.89-.9.72-1.39A1.53,1.53,0,0,1,129.18,167.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M102.57,158.6l2.94,1.69a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.65-.37.89-.9.71-1.39a1.51,1.51,0,0,1-.71.77l-2.92,1.68a4.13,4.13,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77C101.68,157.69,101.92,158.21,102.57,158.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M120.68,162.9l-2.92,1.68a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.56,1.56,0,0,1-.73-.77c-.17.48.07,1,.73,1.39l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.66-.38.89-.9.71-1.39A1.51,1.51,0,0,1,120.68,162.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M133.58,179.44l-2.92,1.68a4.11,4.11,0,0,1-3.74,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77c-.18.48.06,1,.72,1.39l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.66-.37.89-.9.72-1.39A1.54,1.54,0,0,1,133.58,179.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M142.27,184.24l-3.29,1.9a3.76,3.76,0,0,1-3.38,0l-3.3-1.91a1.4,1.4,0,0,1-.64-.67c-.18.45,0,.95.64,1.3l3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.29-1.89c.6-.35.8-.84.62-1.29A1.38,1.38,0,0,1,142.27,184.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M167.77,199l-3.28,1.89a3.72,3.72,0,0,1-3.39,0l-3.3-1.9a1.45,1.45,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l3.3,1.91a3.78,3.78,0,0,0,3.39,0l3.28-1.9c.6-.35.81-.84.63-1.28A1.41,1.41,0,0,1,167.77,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M150.77,189.15,147.49,191a3.75,3.75,0,0,1-3.39,0l-3.3-1.91a1.4,1.4,0,0,1-.64-.67c-.18.45,0,.94.64,1.3l3.3,1.9a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.6-.34.8-.83.62-1.28A1.38,1.38,0,0,1,150.77,189.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M180.19,197.25l-2.92,1.69a4.11,4.11,0,0,1-3.74,0l-2.94-1.69a1.5,1.5,0,0,1-.73-.78c-.17.49.07,1,.73,1.4l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.65-.38.89-.9.71-1.39A1.46,1.46,0,0,1,180.19,197.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M185.4,208.12a1.41,1.41,0,0,1-.63.66l-3.28,1.9a3.76,3.76,0,0,1-3.38,0l-3.31-1.91a1.41,1.41,0,0,1-.63-.66c-.18.45,0,.94.63,1.29l3.31,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89C185.38,209.06,185.58,208.57,185.4,208.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M188.69,202.16l-2.92,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.61,1.61,0,0,1-.73-.77c-.17.49.07,1,.73,1.4l2.94,1.7a4.11,4.11,0,0,0,3.74,0l2.92-1.68c.66-.38.89-.91.71-1.39A1.5,1.5,0,0,1,188.69,202.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M115.48,175.14l2.94,1.69a4.11,4.11,0,0,0,3.74,0l2.92-1.69c.66-.37.89-.9.71-1.39a1.51,1.51,0,0,1-.71.77l-2.92,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.56,1.56,0,0,1-.73-.77C114.58,174.23,114.82,174.76,115.48,175.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M169.34,217.32a1.63,1.63,0,0,1-.73.78l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.59,1.59,0,0,1-.74-.8c-.18.5.07,1,.74,1.42l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64C169.27,218.34,169.51,217.81,169.34,217.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M102.5,176.74l3.31,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89c.61-.35.81-.84.63-1.29a1.41,1.41,0,0,1-.63.66l-3.28,1.9a3.76,3.76,0,0,1-3.38,0l-3.31-1.91a1.38,1.38,0,0,1-.63-.67C101.69,175.89,101.89,176.39,102.5,176.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M76.46,172.79a1.54,1.54,0,0,1-.73.78l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-6.63-3.83a1.59,1.59,0,0,1-.74-.8c-.18.5.07,1,.74,1.42l6.63,3.83a4.24,4.24,0,0,0,3.83,0l2.84-1.64C76.39,173.82,76.63,173.28,76.46,172.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M85,177.69a1.52,1.52,0,0,1-.73.79l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-2.86-1.66a1.58,1.58,0,0,1-.74-.79c-.17.49.07,1,.74,1.42l2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64C84.89,178.72,85.14,178.19,85,177.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M70.3,167.46l15.13,8.73a4.22,4.22,0,0,0,3.82,0l2.84-1.64c.67-.38.91-.91.73-1.41a1.52,1.52,0,0,1-.73.79l-2.84,1.64a4.22,4.22,0,0,1-3.82,0L70.3,166.83a1.58,1.58,0,0,1-.74-.79C69.39,166.53,69.63,167.07,70.3,167.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M153,217a1.55,1.55,0,0,1-.73.79l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-53.86-31.1a1.58,1.58,0,0,1-.75-.8c-.17.5.08,1,.75,1.43L145.57,220a4.24,4.24,0,0,0,3.83,0l2.84-1.64C152.91,218,153.15,217.46,153,217Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M93.46,182.6a1.52,1.52,0,0,1-.73.79L89.89,185a4.19,4.19,0,0,1-3.82,0l-2.87-1.65a1.58,1.58,0,0,1-.74-.79c-.17.49.07,1,.74,1.42l2.87,1.65a4.25,4.25,0,0,0,3.82,0L92.73,184C93.4,183.63,93.64,183.1,93.46,182.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M78.14,162.67l10.66,6.16a3.78,3.78,0,0,0,3.39,0l3.28-1.9c.6-.35.81-.84.63-1.28a1.41,1.41,0,0,1-.63.66l-3.28,1.89a3.72,3.72,0,0,1-3.39,0l-10.66-6.15a1.38,1.38,0,0,1-.63-.67C77.33,161.83,77.53,162.32,78.14,162.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M94.07,153.69,97,155.38a4.13,4.13,0,0,0,3.75,0l2.92-1.69c.65-.37.89-.9.71-1.38a1.5,1.5,0,0,1-.71.76l-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77C93.18,152.78,93.41,153.31,94.07,153.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M86.2,158.23l6.71,3.88a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.65-.38.89-.9.71-1.39a1.46,1.46,0,0,1-.71.76l-2.92,1.69a4.13,4.13,0,0,1-3.75,0l-6.71-3.87a1.52,1.52,0,0,1-.72-.78C85.3,157.32,85.54,157.85,86.2,158.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M202,218.7l-3.28,1.9a3.76,3.76,0,0,1-3.38,0L192,218.68a1.38,1.38,0,0,1-.63-.67c-.18.45,0,1,.63,1.3l3.31,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89c.6-.35.81-.84.63-1.29A1.41,1.41,0,0,1,202,218.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M101.72,149l7.17,4.14a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.6-1.25a1.33,1.33,0,0,1-.6.63,3.63,3.63,0,0,1-3.29,0l-7.17-4.14a1.35,1.35,0,0,1-.62-.64C100.92,148.18,101.12,148.66,101.72,149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M194.08,223.25l-3.28,1.89a3.75,3.75,0,0,1-3.39,0L179,220.29a1.45,1.45,0,0,1-.64-.67c-.18.45,0,.94.64,1.29l8.39,4.85a3.78,3.78,0,0,0,3.39,0l3.28-1.9c.6-.35.8-.83.62-1.28A1.38,1.38,0,0,1,194.08,223.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M209.65,214.26,206.72,216a4.14,4.14,0,0,1-3.74,0l-6.71-3.88a1.56,1.56,0,0,1-.73-.77c-.17.49.07,1,.73,1.4l6.71,3.87a4.11,4.11,0,0,0,3.74,0l2.93-1.69c.65-.37.88-.9.71-1.39A1.56,1.56,0,0,1,209.65,214.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M161.47,221.87a1.55,1.55,0,0,1-.73.79l-2.84,1.64a4.25,4.25,0,0,1-3.82,0l-2.86-1.65a1.62,1.62,0,0,1-.75-.8c-.17.5.07,1,.75,1.42l2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.84-1.64C161.41,222.9,161.65,222.36,161.47,221.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M214.37,211.53a3.63,3.63,0,0,1-3.29,0l-3.39-2a1.35,1.35,0,0,1-.62-.64c-.18.44,0,.92.62,1.27l3.39,2a3.63,3.63,0,0,0,3.29,0c.59-.35.79-.82.61-1.26A1.35,1.35,0,0,1,214.37,211.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M170,226.78a1.52,1.52,0,0,1-.72.78l-2.85,1.65a4.25,4.25,0,0,1-3.82,0l-2.86-1.65a1.55,1.55,0,0,1-.74-.8c-.18.5.07,1,.74,1.42l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64C169.91,227.81,170.15,227.27,170,226.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M177.92,232.57l-2.84,1.65a4.25,4.25,0,0,1-3.82,0l-2.87-1.65a1.64,1.64,0,0,1-.74-.8c-.17.5.07,1,.74,1.42l2.87,1.65a4.19,4.19,0,0,0,3.82,0l2.84-1.64c.67-.38.91-.92.73-1.41A1.5,1.5,0,0,1,177.92,232.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M185.8,228,183,229.67a4.22,4.22,0,0,1-3.82,0L176.27,228a1.55,1.55,0,0,1-.74-.8c-.18.5.07,1,.74,1.43l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.66-.38.9-.91.73-1.41A1.6,1.6,0,0,1,185.8,228Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M173.5,190.45l3.4,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.47,1.47,0,0,1-.61.64,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.37,1.37,0,0,1-.61-.64C172.71,189.63,172.91,190.11,173.5,190.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M193.9,213a1.41,1.41,0,0,1-.63.66l-3.28,1.9a3.76,3.76,0,0,1-3.38,0l-3.3-1.91a1.4,1.4,0,0,1-.64-.67c-.18.45,0,.95.64,1.3l3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89C193.88,214,194.08,213.48,193.9,213Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M197.91,206.31a1.54,1.54,0,0,1-.71.76l-2.93,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.61,1.61,0,0,1-.73-.77c-.17.49.07,1,.73,1.4l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.93-1.69C197.85,207.32,198.08,206.79,197.91,206.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M199,205.18l3.39,2a3.6,3.6,0,0,0,3.29,0c.59-.34.79-.81.61-1.25a1.35,1.35,0,0,1-.61.63,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.35,1.35,0,0,1-.62-.64C198.21,204.35,198.41,204.83,199,205.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M181.11,214.74a1.41,1.41,0,0,1-.63.66l-3.28,1.89a3.73,3.73,0,0,1-3.38,0l-3.3-1.91a1.36,1.36,0,0,1-.64-.67c-.18.45,0,.94.64,1.3l3.3,1.9a3.73,3.73,0,0,0,3.38,0l3.28-1.9C181.09,215.67,181.29,215.19,181.11,214.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M94,171.83l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.6-.35.81-.84.63-1.29a1.32,1.32,0,0,1-.63.66l-3.28,1.9a3.75,3.75,0,0,1-3.39,0l-3.3-1.9a1.37,1.37,0,0,1-.63-.67C93.19,171,93.39,171.48,94,171.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M177.84,222.22a1.56,1.56,0,0,1-.73.79l-2.85,1.64a4.22,4.22,0,0,1-3.82,0L167.58,223a1.54,1.54,0,0,1-.74-.79c-.18.49.07,1,.74,1.42l2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64C177.77,223.25,178,222.72,177.84,222.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M114,156.1l3.4,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.37,1.37,0,0,1-.61.64,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.42,1.42,0,0,1-.61-.64C113.2,155.27,113.4,155.75,114,156.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M91.07,179.44l2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.66-.38.9-.91.72-1.41a1.57,1.57,0,0,1-.72.79l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.55,1.55,0,0,1-.74-.8C90.15,178.52,90.4,179.06,91.07,179.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M190.51,200.27l3.39,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.35,1.35,0,0,1-.61.63,3.66,3.66,0,0,1-3.29,0l-3.39-2a1.41,1.41,0,0,1-.62-.65C189.71,199.44,189.91,199.93,190.51,200.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M148,175.73l3.39,2a3.65,3.65,0,0,0,3.3,0c.59-.35.78-.82.6-1.26a1.33,1.33,0,0,1-.6.63,3.65,3.65,0,0,1-3.3,0l-3.39-2a1.35,1.35,0,0,1-.62-.64C147.2,174.9,147.4,175.38,148,175.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M131,165.91l3.39,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.35,1.35,0,0,1-.61.63,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.44,1.44,0,0,1-.62-.64C130.2,165.09,130.4,165.57,131,165.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M139.5,170.82l3.39,2a3.63,3.63,0,0,0,3.29,0c.6-.34.79-.82.61-1.26a1.35,1.35,0,0,1-.61.63,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.41,1.41,0,0,1-.62-.65C138.7,170,138.9,170.48,139.5,170.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M122.5,161l3.39,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.37,1.37,0,0,1-.61.64,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.4,1.4,0,0,1-.62-.64C121.7,160.18,121.9,160.66,122.5,161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M156.5,180.64l3.4,2a3.63,3.63,0,0,0,3.29,0c.59-.34.78-.82.6-1.25a1.33,1.33,0,0,1-.6.63,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.4,1.4,0,0,1-.62-.64C155.7,179.81,155.9,180.29,156.5,180.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M98.47,165.32l2.94,1.7a4.13,4.13,0,0,0,3.75,0l2.92-1.68c.65-.38.89-.9.71-1.39a1.46,1.46,0,0,1-.71.76l-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.54,1.54,0,0,1-.72-.77C97.58,164.41,97.81,164.94,98.47,165.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M165,185.55l3.4,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.6-1.26a1.3,1.3,0,0,1-.6.64,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.32,1.32,0,0,1-.61-.64C164.2,184.72,164.4,185.2,165,185.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M182,195.36l3.4,2a3.63,3.63,0,0,0,3.29,0c.59-.34.79-.82.61-1.26a1.4,1.4,0,0,1-.61.63,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.44,1.44,0,0,1-.61-.65C181.21,194.53,181.41,195,182,195.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M242.78,208.14,110,131.46c-5.14-3-9.3-10.93-9.3-17.78V9.55c0-6.85,4.16-10,9.3-7L242.78,79.2c5.14,3,9.31,10.93,9.31,17.78V201.11C252.09,208,247.92,211.11,242.78,208.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M244,202.79,112.66,126.94c-4.14-2.63-6.7-7.88-6.7-13.26V9.05a1.65,1.65,0,0,1,2.49-1.42l.29.17L240.17,83.72c4.92,2.84,6.69,7.88,6.69,13.26V201.37a1.78,1.78,0,0,1-2.66,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M240.17,83.72,108.74,7.8l-.29-.17A1.65,1.65,0,0,0,106,9.05V113.68c0,5.38,2.56,10.63,6.7,13.26L244,202.79l.22.13a1.78,1.78,0,0,0,2.66-1.55V97C246.86,91.6,245.09,86.56,240.17,83.72Zm5.65,117.65a.73.73,0,0,1-1.1.64L113.18,126c-3.73-2.37-6.17-7.23-6.17-12.35V9.05a.61.61,0,0,1,.61-.61.58.58,0,0,1,.3.09l131.72,76.1c5.11,2.94,6.18,8.34,6.18,12.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M245.42,77.8,112.68,1.12a6.26,6.26,0,0,0-5.44-.8c-.2.07-2.79,1.45-3,1.55h0c1.58-.77,3.59-.63,5.78.64L242.78,79.2c5.14,3,9.31,10.93,9.31,17.78V201.11c0,4.28-1.63,7.11-4.09,7.91a1.43,1.43,0,0,0,.81-.27c.12-.07,2.93-1.66,3.05-1.74,1.76-1.24,2.86-3.78,2.86-7.3V95.58C254.72,88.73,250.56,80.77,245.42,77.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M243.23,79,110.49,2.29c-2.11-1.21-4-1.39-5.6-.71a6.85,6.85,0,0,1,4.48,1L242.11,79.31c5.14,3,9.31,10.93,9.31,17.78V201.22c0,4-1.46,6.78-3.7,7.75,2.87-.45,4.81-3.4,4.81-8.08V96.76C252.53,89.9,248.37,81.94,243.23,79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-87",
    cx: 250.54,
    cy: 86.89,
    rx: 6.66,
    ry: 10.03,
    transform: "translate(-14.22 101.76) rotate(-22.34)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M133.57,205.32l2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64c.83-.48,1-1.19.52-1.77a1.9,1.9,0,0,1-.52.43l-2.84,1.64a4.24,4.24,0,0,1-3.83,0L133.57,204a2.14,2.14,0,0,1-.52-.45C132.57,204.12,132.74,204.84,133.57,205.32ZM111,183l3.3,1.91a3.73,3.73,0,0,0,3.38,0L121,183c.77-.44.89-1.11.39-1.64a1.83,1.83,0,0,1-.39.31l-3.28,1.89a3.7,3.7,0,0,1-3.38,0l-3.3-1.9a1.93,1.93,0,0,1-.4-.32C110.1,181.86,110.23,182.53,111,183Zm14.06,17.43,2.86,1.65a4.24,4.24,0,0,0,3.83,0l2.84-1.64c.83-.48,1-1.19.52-1.77a1.73,1.73,0,0,1-.52.43l-2.84,1.65a4.27,4.27,0,0,1-3.83,0l-2.86-1.65a2,2,0,0,1-.53-.44C124.07,199.21,124.24,199.93,125.07,200.41Zm-8.5-4.91,2.86,1.65a4.21,4.21,0,0,0,3.83,0l2.84-1.64c.83-.48,1-1.19.52-1.77a1.92,1.92,0,0,1-.52.44l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C115.57,194.31,115.74,195,116.57,195.5ZM128,192.8l3.3,1.9a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.76-.45.89-1.12.38-1.64a1.48,1.48,0,0,1-.38.3l-3.28,1.9a3.78,3.78,0,0,1-3.39,0l-3.3-1.91a1.63,1.63,0,0,1-.4-.31C127.11,191.67,127.23,192.35,128,192.8Zm17,9.81,3.3,1.91a3.78,3.78,0,0,0,3.39,0l3.28-1.9c.77-.44.89-1.11.39-1.64a1.77,1.77,0,0,1-.39.31l-3.28,1.89a3.75,3.75,0,0,1-3.39,0l-3.3-1.91a1.84,1.84,0,0,1-.4-.31C144.11,201.49,144.23,202.17,145,202.61Zm-25.5-14.72,3.3,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89c.77-.45.89-1.12.39-1.64a1.54,1.54,0,0,1-.39.3l-3.28,1.9a3.73,3.73,0,0,1-3.38,0l-3.3-1.9a1.93,1.93,0,0,1-.4-.32C118.6,186.77,118.73,187.44,119.51,187.89Zm65.26,22.85c.77-.44.89-1.11.39-1.64a2.13,2.13,0,0,1-.39.31l-3.28,1.89a3.73,3.73,0,0,1-3.38,0l-3.31-1.91a1.59,1.59,0,0,1-.39-.32c-.51.53-.38,1.2.39,1.65l3.31,1.91a3.76,3.76,0,0,0,3.38,0Zm-85.2-25.05,2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.82-.47,1-1.18.51-1.76a2,2,0,0,1-.51.43L106.25,186a4.19,4.19,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C98.56,184.49,98.73,185.2,99.57,185.69Zm13.29-9.24a2.13,2.13,0,0,1-.39.31l-3.28,1.89a3.73,3.73,0,0,1-3.38,0l-3.31-1.91a1.59,1.59,0,0,1-.39-.32c-.51.53-.38,1.2.39,1.65l3.31,1.91a3.76,3.76,0,0,0,3.38,0l3.28-1.9C113.24,177.65,113.36,177,112.86,176.45Zm37.72,38.69,2.86,1.65a4.22,4.22,0,0,0,3.82,0l2.84-1.64c.83-.47,1-1.18.52-1.76a1.92,1.92,0,0,1-.52.43l-2.84,1.64a4.19,4.19,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C149.57,213.94,149.74,214.65,150.58,215.14Zm-8.51-4.91,2.87,1.65a4.25,4.25,0,0,0,3.82,0l2.84-1.65c.83-.47,1-1.18.52-1.76a1.92,1.92,0,0,1-.52.43l-2.84,1.64a4.22,4.22,0,0,1-3.82,0l-2.87-1.66a1.92,1.92,0,0,1-.52-.44C141.07,209,141.24,209.75,142.07,210.23Zm19.94,2.2,3.31,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89c.77-.45.89-1.12.39-1.64a1.75,1.75,0,0,1-.39.3L168.7,213a3.73,3.73,0,0,1-3.38,0L162,211.1a1.85,1.85,0,0,1-.39-.32C161.11,211.31,161.24,212,162,212.43Zm-25.5-14.72,3.3,1.9a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.77-.44.89-1.11.38-1.64a1.51,1.51,0,0,1-.38.31l-3.28,1.89a3.75,3.75,0,0,1-3.39,0l-3.3-1.91a1.84,1.84,0,0,1-.4-.31C135.61,196.58,135.73,197.26,136.51,197.71Zm17,9.81,3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.77-.44.89-1.11.39-1.64a2.13,2.13,0,0,1-.39.31l-3.28,1.89a3.72,3.72,0,0,1-3.39,0l-3.3-1.9a1.87,1.87,0,0,1-.4-.32C152.61,206.4,152.74,207.07,153.51,207.52Zm22.76-1.69c.77-.44.89-1.11.39-1.64a1.77,1.77,0,0,1-.39.31L173,206.39a3.73,3.73,0,0,1-3.38,0l-3.31-1.91a1.57,1.57,0,0,1-.39-.31c-.51.52-.38,1.2.39,1.64l3.31,1.91a3.76,3.76,0,0,0,3.38,0Zm-59.69-35.58-2.92,1.68a4.16,4.16,0,0,1-3.75,0l-2.93-1.7a2,2,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.75l2.93,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.82-.47,1-1.17.49-1.74A2.08,2.08,0,0,1,116.58,170.25Zm51.19,29.34-3.28,1.9a3.78,3.78,0,0,1-3.39,0l-3.3-1.91a1.84,1.84,0,0,1-.4-.31c-.5.52-.37,1.2.4,1.65l3.3,1.9a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.77-.44.89-1.11.39-1.63A2.1,2.1,0,0,1,167.77,199.59Zm-21.58-21.34-2.92,1.68a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.79,1.79,0,0,1-.5-.42c-.49.57-.32,1.28.5,1.75l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.81-.47,1-1.17.49-1.74A2.08,2.08,0,0,1,146.19,178.25Zm8.5,4.9-2.92,1.69a4.13,4.13,0,0,1-3.75,0l-2.94-1.69a1.79,1.79,0,0,1-.5-.42c-.48.57-.32,1.27.5,1.75l2.94,1.7a4.13,4.13,0,0,0,3.75,0l2.92-1.68c.81-.47,1-1.18.49-1.75A1.69,1.69,0,0,1,154.69,183.15Zm8.5,4.91-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.75,1.75,0,0,1-.5-.41c-.48.57-.32,1.27.5,1.75l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.68c.82-.48,1-1.18.49-1.75A1.69,1.69,0,0,1,163.19,188.06Zm-34-19.63-2.92,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.82,1.82,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.76l2.94,1.69a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.82-.47,1-1.17.5-1.74A1.75,1.75,0,0,1,129.18,168.43Zm-17-9.82-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.69a2.13,2.13,0,0,1-.5-.42c-.48.57-.32,1.27.5,1.75l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.68c.82-.47,1-1.18.49-1.75A1.69,1.69,0,0,1,112.18,158.61Zm8.5,4.91-2.92,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.82,1.82,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.76l2.94,1.69a4.11,4.11,0,0,0,3.74,0l2.92-1.69c.82-.47,1-1.17.5-1.74A1.89,1.89,0,0,1,120.68,163.52Zm51,29.45-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-2.94-1.7a1.92,1.92,0,0,1-.5-.42c-.48.57-.32,1.28.5,1.76L165,196a4.13,4.13,0,0,0,3.75,0l2.92-1.69c.82-.47,1-1.17.49-1.74A1.69,1.69,0,0,1,171.69,193Zm-34-19.63L134.76,175a4.11,4.11,0,0,1-3.74,0l-2.94-1.7a2,2,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.75l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.93-1.69c.81-.47,1-1.17.49-1.74A2,2,0,0,1,137.69,173.34Zm-4.11,6.72-2.92,1.69a4.14,4.14,0,0,1-3.74,0L124,180a1.8,1.8,0,0,1-.51-.41c-.48.56-.32,1.27.51,1.75l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.68c.82-.48,1-1.18.5-1.75A1.75,1.75,0,0,1,133.58,180.06Zm46.61,17.82-2.92,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a1.82,1.82,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.75l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.82-.47,1-1.17.5-1.74A1.89,1.89,0,0,1,180.19,197.88Zm-29.42-8.11-3.28,1.9a3.75,3.75,0,0,1-3.39,0l-3.3-1.9a1.93,1.93,0,0,1-.4-.32c-.5.53-.38,1.2.4,1.65l3.3,1.91a3.75,3.75,0,0,0,3.39,0l3.28-1.89c.77-.45.89-1.12.38-1.64A1.48,1.48,0,0,1,150.77,189.77Zm8.5,4.91-3.28,1.9a3.75,3.75,0,0,1-3.39,0l-3.3-1.91a1.84,1.84,0,0,1-.4-.31c-.5.52-.38,1.2.4,1.65l3.3,1.9a3.72,3.72,0,0,0,3.39,0l3.28-1.89c.77-.45.89-1.12.39-1.64A1.75,1.75,0,0,1,159.27,194.68Zm-17-9.81L139,186.76a3.7,3.7,0,0,1-3.38,0l-3.3-1.9a1.65,1.65,0,0,1-.4-.32c-.5.53-.38,1.2.4,1.65l3.3,1.91a3.73,3.73,0,0,0,3.38,0l3.29-1.89c.76-.44.89-1.11.38-1.64A1.76,1.76,0,0,1,142.27,184.87Zm46.42,17.92-2.92,1.68a4.11,4.11,0,0,1-3.74,0l-2.94-1.7a2,2,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.75l2.94,1.7a4.14,4.14,0,0,0,3.74,0l2.92-1.69c.82-.47,1-1.17.5-1.74A2.15,2.15,0,0,1,188.69,202.79Zm-63.61-27.64-2.92,1.69a4.11,4.11,0,0,1-3.74,0l-2.94-1.69a2,2,0,0,1-.51-.42c-.48.57-.32,1.27.51,1.75l2.94,1.7a4.11,4.11,0,0,0,3.74,0l2.92-1.68c.82-.47,1-1.18.5-1.75A1.75,1.75,0,0,1,125.08,175.15Zm34,44.89,2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.82-.48,1-1.19.51-1.76a2,2,0,0,1-.51.43l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C158.07,218.85,158.24,219.56,159.08,220Zm-51-29.45,2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.85-1.64c.82-.48,1-1.18.51-1.76a1.87,1.87,0,0,1-.51.43l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C107.06,189.4,107.23,190.11,108.07,190.59ZM70.3,168.79l15.13,8.73a4.22,4.22,0,0,0,3.82,0l2.84-1.64c.83-.48,1-1.19.52-1.77a1.76,1.76,0,0,1-.52.43l-2.84,1.64a4.22,4.22,0,0,1-3.82,0L70.3,167.46a2,2,0,0,1-.52-.45C69.3,167.59,69.47,168.31,70.3,168.79Zm14.45,9.88a1.92,1.92,0,0,1-.52.44l-2.84,1.64a4.24,4.24,0,0,1-3.83,0l-2.86-1.65a1.92,1.92,0,0,1-.52-.44c-.48.58-.31,1.29.52,1.77l2.86,1.65a4.21,4.21,0,0,0,3.83,0l2.84-1.64C85.06,180,85.22,179.25,84.75,178.67Zm-8.5-4.9a2.09,2.09,0,0,1-.52.43l-2.84,1.64a4.24,4.24,0,0,1-3.83,0L62.43,172a1.83,1.83,0,0,1-.53-.44c-.48.58-.31,1.29.53,1.78l6.63,3.83a4.24,4.24,0,0,0,3.83,0l2.84-1.64C76.56,175.05,76.72,174.35,76.25,173.77Zm76.51,44.17a1.76,1.76,0,0,1-.52.43L149.4,220a4.24,4.24,0,0,1-3.83,0l-53.86-31.1a2,2,0,0,1-.53-.45c-.48.58-.31,1.3.53,1.78l53.86,31.1a4.27,4.27,0,0,0,3.83,0l2.84-1.64C153.07,219.23,153.23,218.52,152.76,217.94ZM93.25,183.58a1.62,1.62,0,0,1-.52.43l-2.84,1.65a4.25,4.25,0,0,1-3.82,0L83.2,184a2.11,2.11,0,0,1-.52-.44c-.48.57-.31,1.29.52,1.77L86.07,187a4.22,4.22,0,0,0,3.82,0l2.84-1.64C93.56,184.87,93.72,184.16,93.25,183.58ZM94.07,155l2.94,1.7a4.13,4.13,0,0,0,3.75,0l2.92-1.68c.82-.47,1-1.18.49-1.75a1.69,1.69,0,0,1-.49.41l-2.92,1.69a4.13,4.13,0,0,1-3.75,0l-2.94-1.69a2.13,2.13,0,0,1-.5-.42C93.09,153.84,93.25,154.54,94.07,155Zm-15.93,9,10.66,6.15a3.75,3.75,0,0,0,3.39,0l3.28-1.9c.77-.44.89-1.11.39-1.64a1.77,1.77,0,0,1-.39.31l-3.28,1.9a3.78,3.78,0,0,1-3.39,0l-10.66-6.16a1.57,1.57,0,0,1-.39-.31C77.24,162.88,77.37,163.56,78.14,164Zm8.06-4.44,6.71,3.87a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.82-.47,1-1.17.49-1.74a1.69,1.69,0,0,1-.49.41l-2.92,1.69a4.16,4.16,0,0,1-3.75,0l-6.71-3.88a1.82,1.82,0,0,1-.51-.42C85.21,158.38,85.37,159.09,86.2,159.57Zm83.56,68.19a2,2,0,0,1-.51.43l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44c-.48.58-.31,1.29.53,1.77l2.86,1.66a4.22,4.22,0,0,0,3.82,0l2.85-1.64C170.07,229.05,170.24,228.34,169.76,227.76Zm-8.5-4.91a1.92,1.92,0,0,1-.52.43l-2.84,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.66a1.83,1.83,0,0,1-.53-.44c-.48.58-.31,1.29.53,1.78l2.86,1.65a4.25,4.25,0,0,0,3.82,0l2.84-1.65C161.57,224.14,161.73,223.43,161.26,222.85ZM202,219.33l-3.28,1.89a3.7,3.7,0,0,1-3.38,0l-3.31-1.9a1.59,1.59,0,0,1-.39-.32c-.51.53-.38,1.2.39,1.65l3.31,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89c.77-.44.89-1.11.39-1.64A2.13,2.13,0,0,1,202,219.33Zm-7.87,4.54-3.28,1.9a3.78,3.78,0,0,1-3.39,0L179,220.91a1.63,1.63,0,0,1-.4-.31c-.51.52-.38,1.2.4,1.65l8.39,4.84a3.72,3.72,0,0,0,3.39,0l3.28-1.89c.77-.45.89-1.12.38-1.64A1.48,1.48,0,0,1,194.08,223.87Zm20.65-12a1.8,1.8,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.64,1.64,0,0,1-.37-.29c-.52.51-.4,1.18.37,1.62l3.39,2a3.63,3.63,0,0,0,3.29,0C215.13,213.05,215.24,212.39,214.73,211.88Zm-5.08,3-2.93,1.69a4.11,4.11,0,0,1-3.74,0l-6.71-3.87a2,2,0,0,1-.51-.42c-.48.57-.32,1.28.51,1.75L203,217.9a4.11,4.11,0,0,0,3.74,0l2.93-1.68c.81-.47,1-1.18.49-1.75A1.84,1.84,0,0,1,209.65,214.88ZM185.8,228.65,183,230.29a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a2,2,0,0,1-.53-.45c-.48.58-.31,1.3.53,1.78l2.86,1.65a4.22,4.22,0,0,0,3.82,0L185.8,230c.82-.48,1-1.19.51-1.77A1.71,1.71,0,0,1,185.8,228.65Zm-84.08-78.31,7.17,4.14a3.63,3.63,0,0,0,3.29,0c.76-.44.87-1.1.36-1.61a1.78,1.78,0,0,1-.36.27,3.63,3.63,0,0,1-3.29,0L101.72,149a1.9,1.9,0,0,1-.37-.29C100.84,149.23,101,149.9,101.72,150.34Zm76.2,82.86-2.84,1.64a4.19,4.19,0,0,1-3.82,0l-2.87-1.65a1.92,1.92,0,0,1-.52-.44c-.48.58-.31,1.29.52,1.78l2.87,1.65a4.22,4.22,0,0,0,3.82,0l2.84-1.64c.83-.47,1-1.18.52-1.76A1.92,1.92,0,0,1,177.92,233.2Zm-4.42-41.41,3.4,2a3.63,3.63,0,0,0,3.29,0c.76-.43.87-1.09.36-1.61a1.5,1.5,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.56,1.56,0,0,1-.37-.28C172.62,190.68,172.74,191.35,173.5,191.79ZM197.2,209c.81-.47,1-1.17.49-1.74a2,2,0,0,1-.49.4l-2.93,1.69a4.14,4.14,0,0,1-3.74,0l-2.94-1.7a2,2,0,0,1-.51-.42c-.48.57-.32,1.27.51,1.75l2.94,1.7a4.11,4.11,0,0,0,3.74,0Zm-6.69-7.43,3.39,2a3.63,3.63,0,0,0,3.29,0c.76-.44.87-1.1.36-1.61a1.8,1.8,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.64,1.64,0,0,1-.37-.29C189.62,200.5,189.74,201.16,190.51,201.6Zm8.5,4.91,3.39,2a3.63,3.63,0,0,0,3.29,0c.76-.44.87-1.1.36-1.61a1.78,1.78,0,0,1-.36.27,3.6,3.6,0,0,1-3.29,0l-3.39-2a1.9,1.9,0,0,1-.37-.29C198.12,205.4,198.24,206.07,199,206.51Zm-18.14,9.21a1.75,1.75,0,0,1-.39.3l-3.28,1.9a3.73,3.73,0,0,1-3.38,0l-3.3-1.91a1.46,1.46,0,0,1-.4-.31c-.51.52-.38,1.2.4,1.65l3.3,1.9a3.7,3.7,0,0,0,3.38,0l3.28-1.89C181.25,216.91,181.37,216.24,180.87,215.72ZM114,157.43l3.4,2a3.63,3.63,0,0,0,3.29,0c.76-.44.87-1.1.36-1.62a1.5,1.5,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a2.27,2.27,0,0,1-.37-.29C113.11,156.32,113.23,157,114,157.43Zm-20,14.4a1.57,1.57,0,0,1-.39-.31c-.51.52-.38,1.2.39,1.64l3.3,1.91a3.78,3.78,0,0,0,3.39,0l3.28-1.9c.77-.44.89-1.11.39-1.64a1.77,1.77,0,0,1-.39.31l-3.28,1.89a3.75,3.75,0,0,1-3.39,0ZM90.54,179c-.48.58-.31,1.3.53,1.78l2.86,1.65a4.25,4.25,0,0,0,3.82,0l2.85-1.64c.82-.48,1-1.19.51-1.77a2,2,0,0,1-.51.43l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.66A1.83,1.83,0,0,1,90.54,179Zm77,45.95,2.86,1.65a4.19,4.19,0,0,0,3.82,0l2.85-1.64c.82-.48,1-1.19.51-1.77a1.73,1.73,0,0,1-.51.44l-2.85,1.64a4.22,4.22,0,0,1-3.82,0l-2.86-1.65a1.83,1.83,0,0,1-.53-.44C166.57,223.76,166.74,224.47,167.58,225Zm15.73-9.32,3.3,1.91a3.73,3.73,0,0,0,3.38,0l3.28-1.89c.77-.44.89-1.11.39-1.64a1.83,1.83,0,0,1-.39.31L190,216.21a3.7,3.7,0,0,1-3.38,0l-3.3-1.9a1.93,1.93,0,0,1-.4-.32C182.4,214.51,182.53,215.18,183.31,215.63ZM139.5,172.15l3.39,2a3.63,3.63,0,0,0,3.29,0c.76-.44.87-1.1.36-1.61a1.55,1.55,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.9,1.9,0,0,1-.37-.29C138.62,171.05,138.73,171.71,139.5,172.15Zm-8.5-4.9,3.39,2a3.63,3.63,0,0,0,3.29,0c.76-.43.87-1.1.36-1.61a1.8,1.8,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.36,1.36,0,0,1-.37-.29C130.11,166.14,130.23,166.8,131,167.25Zm51,29.45,3.4,2a3.66,3.66,0,0,0,3.29,0c.76-.43.87-1.1.36-1.61a1.8,1.8,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.83,1.83,0,0,1-.37-.29C181.12,195.59,181.24,196.25,182,196.7Zm-34-19.64,3.4,2a3.63,3.63,0,0,0,3.29,0c.75-.44.86-1.1.36-1.61a2.14,2.14,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.9,1.9,0,0,1-.37-.29C147.12,176,147.24,176.62,148,177.06Zm-25.5-14.72,3.39,2a3.63,3.63,0,0,0,3.29,0c.76-.43.87-1.09.36-1.61a1.5,1.5,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.39-2a1.38,1.38,0,0,1-.37-.28C121.61,161.23,121.73,161.9,122.5,162.34Zm34,19.63,3.4,2a3.63,3.63,0,0,0,3.29,0c.75-.44.87-1.1.36-1.62a1.72,1.72,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.9,1.9,0,0,1-.37-.29C155.62,180.86,155.74,181.53,156.5,182Zm-48.42-16.63L105.16,167a4.13,4.13,0,0,1-3.75,0l-2.94-1.7a2.13,2.13,0,0,1-.5-.42c-.48.57-.32,1.28.5,1.75l2.94,1.7a4.16,4.16,0,0,0,3.75,0l2.92-1.69c.82-.47,1-1.17.49-1.74A2.08,2.08,0,0,1,108.08,165.34ZM165,186.88l3.4,2a3.63,3.63,0,0,0,3.29,0c.75-.44.87-1.1.36-1.62a1.5,1.5,0,0,1-.36.28,3.63,3.63,0,0,1-3.29,0l-3.4-2a1.9,1.9,0,0,1-.37-.29C164.12,185.77,164.24,186.44,165,186.88Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "199.87 121.1 162.2 99.35 162.2 79.36 199.87 101.11 199.87 121.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "134.21 83.47 96.53 61.72 96.53 41.73 134.21 63.48 134.21 83.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M165.67,36.6l-31-17.92c-2.65-1.53-4.8-5.63-4.8-9.16h0c0-3.53,2.15-5.15,4.8-3.62l31,17.92c2.65,1.53,4.79,5.63,4.79,9.16h0C170.46,36.51,168.32,38.13,165.67,36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M164.05,134l-31-17.92c-2.65-1.53-4.8-5.63-4.8-9.16h0c0-3.53,2.15-5.15,4.8-3.62l31,17.92c2.64,1.53,4.79,5.63,4.79,9.16h0C168.84,134,166.69,135.57,164.05,134Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "183.15 85.43 183.15 74.94 167.94 66.41 167.44 67.28 182.15 75.53 182.15 84.85 179.99 83.6 182.42 89.85 184.85 86.41 183.15 85.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "149.56 39.75 151.99 36.3 150.09 35.2 150.09 29.35 149.09 29.05 149.09 34.63 147.13 33.5 149.56 39.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "117.66 52.91 120.08 49.47 118.34 48.47 118.34 38.9 129.57 45.41 130.07 44.54 117.34 37.17 117.34 47.89 115.22 46.67 117.66 52.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "179.65 116.16 115.65 79.32 115.65 73.29 114.65 72.99 114.65 79.89 149.09 99.78 149.09 107.25 147.13 106.13 149.56 112.38 151.99 108.93 150.09 107.83 150.09 100.36 179.9 117.46 180.65 117.89 180.65 110.54 179.65 110.24 179.65 116.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "149.44 71.8 130.38 45.05 149.44 40.32 168.5 67.07 149.44 71.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "162.2 79.36 162.2 80.15 199.37 101.61 199.37 120.81 199.87 121.1 199.87 101.11 162.2 79.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "96.53 41.73 96.53 42.52 133.71 63.98 133.71 83.18 134.21 83.47 134.21 63.48 96.53 41.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M165.67,23.82l-31-17.92c-1.6-.93-3-.69-3.88.41a2.94,2.94,0,0,1,3.38.09l31,17.92C167.81,25.85,170,30,170,33.48a5.13,5.13,0,0,1-.91,3.21A4.49,4.49,0,0,0,170.46,33C170.46,29.45,168.31,25.35,165.67,23.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M164.05,121.26l-31-17.92c-1.6-.92-3-.69-3.88.41a3,3,0,0,1,3.38.09l31,17.92c2.64,1.53,4.79,5.63,4.79,9.16a5.13,5.13,0,0,1-.91,3.21,4.49,4.49,0,0,0,1.41-3.71C168.84,126.89,166.69,122.79,164.05,121.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "148.94 40.82 167.78 67.25 168.5 67.07 149.44 40.32 130.38 45.05 130.61 45.38 148.94 40.82"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M217.07,87a4.9,4.9,0,0,1-.59-2.4V78.76c0-.89.2-1.46.59-1.72s1-.17,1.71.26A4.48,4.48,0,0,1,220.49,79a4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.46,4.46,0,0,1,217.07,87Zm2.5-.5v-6a1.66,1.66,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C219.3,87.41,219.57,87.19,219.57,86.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M218.71,95.14l-1.58-.91V93a4.53,4.53,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.22,1.22,0,0,0,.42-.6l1,.59v11.06l-1.52-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M217.07,117.17a4.9,4.9,0,0,1-.59-2.4V109c0-.89.2-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,217.07,117.17Zm2.5-.5v-6a1.65,1.65,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C219.3,117.6,219.57,117.39,219.57,116.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M217.07,132.27a4.9,4.9,0,0,1-.59-2.4v-5.81c0-.89.2-1.46.59-1.72s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,217.07,132.27Zm2.5-.51v-6a1.65,1.65,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C219.3,132.7,219.57,132.49,219.57,131.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M218.71,140.44l-1.58-.91V138.3a5,5,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.22,1.22,0,0,0,.42-.6l1,.58v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M217.07,162.47a4.9,4.9,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,217.07,162.47Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C219.3,162.9,219.57,162.69,219.57,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M218.71,170.64l-1.58-.91v-1.24a4.65,4.65,0,0,0,1,.48.74.74,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59V180l-1.52-.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M225.69,84.07l-1.59-.91V81.92a4.65,4.65,0,0,0,1,.48.77.77,0,0,0,.63-.06,1.32,1.32,0,0,0,.41-.61l1,.59V93.39l-1.51-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M224.05,106.1a4.83,4.83,0,0,1-.6-2.4V97.88q0-1.32.6-1.71c.39-.26,1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.59,2.4v5.82c0,.88-.19,1.45-.59,1.71s-1,.17-1.71-.26A4.43,4.43,0,0,1,224.05,106.1Zm2.49-.51v-6a1.63,1.63,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C226.28,106.53,226.54,106.32,226.54,105.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M225.69,114.27l-1.59-.91v-1.24a4.65,4.65,0,0,0,1,.48.82.82,0,0,0,.63-.06,1.37,1.37,0,0,0,.41-.61l1,.59v11.07l-1.51-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M224.05,136.3a4.86,4.86,0,0,1-.6-2.4v-5.82q0-1.32.6-1.71c.39-.26,1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.59,2.4v5.82c0,.88-.19,1.45-.59,1.71s-1,.17-1.71-.26A4.43,4.43,0,0,1,224.05,136.3Zm2.49-.51v-6a1.63,1.63,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.55C226.28,136.73,226.54,136.52,226.54,135.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M224.05,151.4a4.86,4.86,0,0,1-.6-2.4v-5.82c0-.88.2-1.46.6-1.71s1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.59,2.4v5.81c0,.89-.19,1.46-.59,1.72s-1,.17-1.71-.26A4.43,4.43,0,0,1,224.05,151.4Zm2.49-.51v-6a1.62,1.62,0,0,0-.79-1.54q-.78-.45-.78.63v6a1.64,1.64,0,0,0,.78,1.55C226.28,151.83,226.54,151.62,226.54,150.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M225.69,159.57l-1.59-.92v-1.23a4.13,4.13,0,0,0,1,.47.78.78,0,0,0,.63,0,1.37,1.37,0,0,0,.41-.61l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M224.05,181.59a4.79,4.79,0,0,1-.6-2.39v-5.82q0-1.33.6-1.71c.39-.26,1-.17,1.7.26a4.33,4.33,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.59,2.4v5.81c0,.89-.19,1.46-.59,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,224.05,181.59Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C226.28,182,226.54,181.82,226.54,181.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M231,95a4.79,4.79,0,0,1-.59-2.39V86.81c0-.89.19-1.46.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4v5.81c0,.89-.2,1.46-.59,1.72s-1,.17-1.71-.26A4.35,4.35,0,0,1,231,95Zm2.49-.5v-6a1.63,1.63,0,0,0-.78-1.54c-.53-.31-.79-.09-.79.63v6a1.64,1.64,0,0,0,.79,1.55C233.25,95.46,233.51,95.25,233.51,94.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M231,110.12a4.79,4.79,0,0,1-.59-2.39v-5.82c0-.89.19-1.46.59-1.71s1-.17,1.71.25a4.55,4.55,0,0,1,1.71,1.72,4.9,4.9,0,0,1,.59,2.4v5.81c0,.89-.2,1.46-.59,1.72s-1,.17-1.71-.26A4.35,4.35,0,0,1,231,110.12Zm2.49-.5v-6a1.63,1.63,0,0,0-.78-1.54c-.53-.31-.79-.09-.79.63v6a1.64,1.64,0,0,0,.79,1.55C233.25,110.56,233.51,110.35,233.51,109.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M231,125.22a4.79,4.79,0,0,1-.59-2.39V117c0-.89.19-1.46.59-1.71s1-.18,1.71.25a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.72s-1,.17-1.71-.26A4.35,4.35,0,0,1,231,125.22Zm2.49-.5v-6a1.63,1.63,0,0,0-.78-1.54c-.53-.31-.79-.09-.79.63v6a1.64,1.64,0,0,0,.79,1.55C233.25,125.66,233.51,125.45,233.51,124.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M232.66,133.4l-1.59-.92v-1.23a4.29,4.29,0,0,0,1,.47.77.77,0,0,0,.63-.05,1.23,1.23,0,0,0,.41-.61l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M232.66,148.5l-1.59-.92v-1.23a4.29,4.29,0,0,0,1,.47.73.73,0,0,0,.63-.06,1.15,1.15,0,0,0,.41-.6l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M232.66,163.59l-1.59-.91v-1.23a4.73,4.73,0,0,0,1,.47.73.73,0,0,0,.63-.06,1.15,1.15,0,0,0,.41-.6l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M231,185.62a4.8,4.8,0,0,1-.59-2.4v-5.81c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,231,185.62Zm2.49-.5v-6a1.64,1.64,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54Q233.51,186.2,233.51,185.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M239.63,92.12l-1.58-.91V90a4.53,4.53,0,0,0,1,.47.74.74,0,0,0,.63-.06,1.28,1.28,0,0,0,.41-.6l1,.59v11.06l-1.52-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M239.63,107.22l-1.58-.91v-1.23a4.53,4.53,0,0,0,1,.47.74.74,0,0,0,.63-.06,1.28,1.28,0,0,0,.41-.6l1,.58v11.07l-1.52-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M239.63,122.32l-1.58-.91v-1.23a5,5,0,0,0,1,.47.74.74,0,0,0,.63-.06,1.28,1.28,0,0,0,.41-.6l1,.58v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M238,144.35a4.9,4.9,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.46,4.46,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,238,144.35Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C240.22,144.78,240.49,144.57,240.49,143.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M238,159.45a4.93,4.93,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.46,4.46,0,0,1,1.71,1.71,4.93,4.93,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,238,159.45Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C240.22,159.88,240.49,159.67,240.49,158.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M238,174.55a4.93,4.93,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.46,4.46,0,0,1,1.71,1.71A4.9,4.9,0,0,1,242,169v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,238,174.55Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C240.22,175,240.49,174.77,240.49,174Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M239.63,182.72l-1.58-.91v-1.24a4.65,4.65,0,0,0,1,.48.82.82,0,0,0,.63-.06,1.37,1.37,0,0,0,.41-.61l1,.59V192l-1.52-.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M168.52,51.74l-1.59-.92V49.59a4.29,4.29,0,0,0,1,.47.77.77,0,0,0,.63-.05,1.3,1.3,0,0,0,.41-.61l1,.59V61.05l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M166.88,73.76a4.79,4.79,0,0,1-.59-2.39V65.55c0-.89.19-1.46.59-1.71s1-.17,1.71.26a4.46,4.46,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4V74c0,.89-.2,1.46-.59,1.72s-1,.17-1.71-.26A4.35,4.35,0,0,1,166.88,73.76Zm2.49-.5v-6a1.63,1.63,0,0,0-.78-1.54c-.53-.31-.79-.09-.79.63v6a1.64,1.64,0,0,0,.79,1.55C169.11,74.2,169.37,74,169.37,73.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M168.52,81.94,166.93,81V79.79a4.29,4.29,0,0,0,1,.47.77.77,0,0,0,.63-.05,1.3,1.3,0,0,0,.41-.61l1,.59V91.25l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M166.88,104a4.79,4.79,0,0,1-.59-2.39V95.75c0-.89.19-1.46.59-1.72s1-.17,1.71.26A4.48,4.48,0,0,1,170.3,96a4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.71s-1,.18-1.71-.25A4.35,4.35,0,0,1,166.88,104Zm2.49-.5v-6a1.65,1.65,0,0,0-.78-1.55c-.53-.3-.79-.08-.79.64v6a1.62,1.62,0,0,0,.79,1.54C169.11,104.4,169.37,104.18,169.37,103.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M166.88,119.06a4.8,4.8,0,0,1-.59-2.4v-5.81c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.71s-1,.17-1.71-.25A4.41,4.41,0,0,1,166.88,119.06Zm2.49-.5v-6a1.65,1.65,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54C169.11,119.5,169.37,119.28,169.37,118.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M168.52,127.24l-1.59-.92v-1.23a4.73,4.73,0,0,0,1,.47.73.73,0,0,0,.63-.06,1.21,1.21,0,0,0,.41-.6l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M166.88,149.26a4.8,4.8,0,0,1-.59-2.4v-5.81c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,166.88,149.26Zm2.49-.5v-6a1.65,1.65,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54C169.11,149.7,169.37,149.48,169.37,148.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M173.85,62.69a4.9,4.9,0,0,1-.59-2.4V54.48c0-.89.2-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39V63c0,.89-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,173.85,62.69Zm2.5-.5v-6a1.66,1.66,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C176.08,63.13,176.35,62.91,176.35,62.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M173.85,77.79a4.9,4.9,0,0,1-.59-2.4V69.58c0-.89.2-1.46.59-1.72s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,173.85,77.79Zm2.5-.5v-6a1.65,1.65,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C176.08,78.22,176.35,78,176.35,77.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M173.85,92.89a4.9,4.9,0,0,1-.59-2.4V84.67c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,173.85,92.89Zm2.5-.51v-6a1.65,1.65,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C176.08,93.32,176.35,93.11,176.35,92.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M175.49,101.06l-1.58-.91V98.92a5,5,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M175.49,116.16l-1.58-.91V114a4.65,4.65,0,0,0,1,.48.71.71,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M175.49,131.26l-1.58-.91v-1.24a4.65,4.65,0,0,0,1,.48.74.74,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M173.85,153.29a5,5,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,173.85,153.29Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C176.08,153.72,176.35,153.51,176.35,152.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M182.47,59.79l-1.59-.91V57.64a4.65,4.65,0,0,0,1,.48.77.77,0,0,0,.63-.06,1.32,1.32,0,0,0,.41-.61l1,.59V69.11l-1.51-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M182.47,74.89,180.88,74V72.74a4.65,4.65,0,0,0,1,.48.82.82,0,0,0,.63-.06,1.37,1.37,0,0,0,.41-.61l1,.59V84.21l-1.51-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M182.47,90l-1.59-.92V87.84a4.65,4.65,0,0,0,1,.48.82.82,0,0,0,.63-.06,1.37,1.37,0,0,0,.41-.61l1,.59V99.31l-1.51-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M180.83,112a4.79,4.79,0,0,1-.6-2.39V103.8c0-.88.2-1.46.6-1.71s1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,180.83,112Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54q-.78-.45-.78.63v6a1.64,1.64,0,0,0,.78,1.55C183.06,112.45,183.32,112.24,183.32,111.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M180.83,127.11a4.79,4.79,0,0,1-.6-2.39V118.9q0-1.34.6-1.71c.39-.26,1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,180.83,127.11Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C183.06,127.55,183.32,127.34,183.32,126.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M180.83,142.21a4.79,4.79,0,0,1-.6-2.39V134q0-1.33.6-1.71c.39-.26,1-.17,1.7.26a4.33,4.33,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,180.83,142.21Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C183.06,142.65,183.32,142.44,183.32,141.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M182.47,150.39l-1.59-.92v-1.23a4.13,4.13,0,0,0,1,.47.78.78,0,0,0,.63-.05,1.37,1.37,0,0,0,.41-.61l1,.59V159.7l-1.51-.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M188.26,71a4.79,4.79,0,0,1-.59-2.39V62.83c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39V71.3c0,.89-.2,1.46-.59,1.71s-1,.18-1.71-.25A4.41,4.41,0,0,1,188.26,71Zm2.49-.5v-6A1.65,1.65,0,0,0,190,63c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54C190.49,71.48,190.75,71.26,190.75,70.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M189.9,79.22l-1.59-.92V77.07a4.29,4.29,0,0,0,1,.47.73.73,0,0,0,.63-.06,1.21,1.21,0,0,0,.41-.6l1,.59V88.53l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M188.26,101.24a4.8,4.8,0,0,1-.59-2.4V93c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.89-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,188.26,101.24Zm2.49-.5v-6a1.65,1.65,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54C190.49,101.68,190.75,101.46,190.75,100.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M188.26,116.34a4.8,4.8,0,0,1-.59-2.4v-5.81c0-.89.19-1.46.59-1.72s1-.17,1.71.26a4.48,4.48,0,0,1,1.71,1.72,4.89,4.89,0,0,1,.59,2.39v5.82c0,.88-.2,1.46-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,188.26,116.34Zm2.49-.5v-6a1.64,1.64,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.62,1.62,0,0,0,.79,1.54C190.49,116.78,190.75,116.56,190.75,115.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M189.9,124.51l-1.59-.91v-1.23a4.73,4.73,0,0,0,1,.47.73.73,0,0,0,.63-.06,1.21,1.21,0,0,0,.41-.6l1,.58v11.07L189.9,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M188.26,146.54a4.8,4.8,0,0,1-.59-2.4v-5.82c0-.88.19-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,188.26,146.54Zm2.49-.51v-6a1.64,1.64,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.63,1.63,0,0,0,.79,1.54C190.49,147,190.75,146.76,190.75,146Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M189.9,154.71l-1.59-.91v-1.24a4.87,4.87,0,0,0,1,.48A.73.73,0,0,0,190,153a1.25,1.25,0,0,0,.41-.61l1,.59V164l-1.51-.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M196.87,68.14l-1.58-.91V66a4.65,4.65,0,0,0,1,.48.71.71,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59V77.46l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M195.23,90.17a4.9,4.9,0,0,1-.59-2.4V82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.93,4.93,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,195.23,90.17Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.54C197.46,90.6,197.73,90.39,197.73,89.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M196.87,98.34l-1.58-.91V96.19a4.65,4.65,0,0,0,1,.48.74.74,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59v11.07l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M195.23,120.37a5,5,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,195.23,120.37Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.55C197.46,120.8,197.73,120.59,197.73,119.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M195.23,135.47a5,5,0,0,1-.59-2.4v-5.82c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.53,4.53,0,0,1,195.23,135.47Zm2.5-.51v-6a1.64,1.64,0,0,0-.79-1.54c-.52-.3-.78-.09-.78.64v6a1.64,1.64,0,0,0,.78,1.55C197.46,135.9,197.73,135.69,197.73,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M196.87,143.64l-1.58-.92v-1.23a4.65,4.65,0,0,0,1,.48.78.78,0,0,0,.62-.06,1.3,1.3,0,0,0,.42-.61l1,.59V153l-1.52-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M195.23,165.66a4.89,4.89,0,0,1-.59-2.39v-5.82c0-.89.2-1.46.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.9,4.9,0,0,1,.59,2.4v5.81c0,.89-.2,1.46-.59,1.72s-1,.17-1.71-.26A4.48,4.48,0,0,1,195.23,165.66Zm2.5-.5v-6a1.63,1.63,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C197.46,166.1,197.73,165.89,197.73,165.16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M202.21,79.09a4.79,4.79,0,0,1-.6-2.39V70.88q0-1.34.6-1.71c.39-.26,1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,202.21,79.09Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C204.44,79.53,204.7,79.32,204.7,78.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M202.21,94.19a4.79,4.79,0,0,1-.6-2.39V86q0-1.33.6-1.71c.39-.26,1-.17,1.7.26a4.39,4.39,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,202.21,94.19Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C204.44,94.63,204.7,94.42,204.7,93.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M202.21,109.29a4.79,4.79,0,0,1-.6-2.39v-5.82q0-1.33.6-1.71c.39-.26,1-.17,1.7.26a4.33,4.33,0,0,1,1.71,1.71,4.8,4.8,0,0,1,.6,2.4v5.81c0,.89-.2,1.46-.6,1.72s-1,.17-1.71-.26A4.39,4.39,0,0,1,202.21,109.29Zm2.49-.5v-6a1.62,1.62,0,0,0-.79-1.54c-.52-.31-.78-.09-.78.63v6a1.65,1.65,0,0,0,.78,1.55C204.44,109.73,204.7,109.52,204.7,108.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M203.85,117.47l-1.59-.92v-1.23a4.13,4.13,0,0,0,1,.47.78.78,0,0,0,.63-.05,1.37,1.37,0,0,0,.41-.61l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M203.85,132.57l-1.59-.92v-1.23a4.13,4.13,0,0,0,1,.47.78.78,0,0,0,.63,0,1.37,1.37,0,0,0,.41-.61l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M203.85,147.67l-1.59-.92v-1.23a4.13,4.13,0,0,0,1,.47.74.74,0,0,0,.63-.06,1.28,1.28,0,0,0,.41-.6l1,.59V157l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M202.21,169.69a4.8,4.8,0,0,1-.6-2.4v-5.81c0-.89.2-1.46.6-1.72s1-.17,1.7.26a4.35,4.35,0,0,1,1.71,1.72,4.79,4.79,0,0,1,.6,2.39V170q0,1.34-.6,1.71c-.39.26-1,.17-1.71-.26A4.43,4.43,0,0,1,202.21,169.69Zm2.49-.5v-6a1.64,1.64,0,0,0-.79-1.55c-.52-.3-.78-.09-.78.64v6a1.63,1.63,0,0,0,.78,1.54C204.44,170.13,204.7,169.91,204.7,169.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M210.82,76.19l-1.58-.91V74.05a4.35,4.35,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.22,1.22,0,0,0,.42-.6l1,.59V85.51l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M210.82,91.29l-1.58-.91V89.15a4.35,4.35,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.22,1.22,0,0,0,.42-.6l1,.59v11.06l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M210.82,106.39l-1.58-.91v-1.23a4.35,4.35,0,0,0,1,.47.71.71,0,0,0,.62-.06,1.22,1.22,0,0,0,.42-.6l1,.58v11.07l-1.51-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M209.18,128.42a4.9,4.9,0,0,1-.59-2.4V120.2c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,209.18,128.42Zm2.49-.51v-6a1.64,1.64,0,0,0-.78-1.55c-.53-.3-.79-.09-.79.64v6a1.63,1.63,0,0,0,.79,1.54C211.41,128.85,211.67,128.64,211.67,127.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M209.18,143.52a4.9,4.9,0,0,1-.59-2.4V135.3c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,5,5,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,209.18,143.52Zm2.49-.51v-6a1.64,1.64,0,0,0-.78-1.54c-.53-.3-.79-.09-.79.64v6a1.63,1.63,0,0,0,.79,1.54C211.41,144,211.67,143.74,211.67,143Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M209.18,158.62a4.9,4.9,0,0,1-.59-2.4V150.4c0-.88.2-1.45.59-1.71s1-.17,1.71.26a4.53,4.53,0,0,1,1.71,1.71,4.93,4.93,0,0,1,.59,2.4v5.82c0,.88-.2,1.45-.59,1.71s-1,.17-1.71-.26A4.39,4.39,0,0,1,209.18,158.62Zm2.49-.51v-6a1.64,1.64,0,0,0-.78-1.54c-.53-.3-.79-.09-.79.64v6a1.63,1.63,0,0,0,.79,1.54C211.41,159.05,211.67,158.84,211.67,158.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M210.82,166.79l-1.58-.91v-1.24a4.46,4.46,0,0,0,1,.48.74.74,0,0,0,.62-.06,1.25,1.25,0,0,0,.42-.61l1,.59v11.07l-1.51-.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M70.52,32.32c-6.22-3.59-11.26-.72-11.26,6.41v88.4c0,7.13,5,15.82,11.26,19.41l48.3,29.19c6.22,3.59,25-14.2,25-21.34V86.25c0-7.13-7.53-15.43-13.74-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M69.68,32.77c-6.15-3.55-11.14-.71-11.14,6.35v87.66c0,7.06,5,15.66,11.14,19.22l49,29.46c6.15,3.55,23.6-12.86,23.6-19.92V86.3c0-7.06-7.25-15.3-13.4-18.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M68.85,33.23c-6.09-3.52-11-.7-11,6.29v86.91c0,7,4.94,15.51,11,19l49.63,29.74c6.09,3.51,22.24-11.51,22.24-18.5V86.35c0-7-7-15.18-13.06-18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M68,33.69C62,30.21,57.1,33,57.1,39.91v86.18C57.1,133,62,141.43,68,144.91l50.29,30c6,3.48,20.88-10.16,20.88-17.07V86.4c0-6.91-6.7-15.05-12.73-18.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M67.18,34.15c-6-3.45-10.8-.69-10.8,6.15v85.44c0,6.84,4.84,15.18,10.8,18.63l50.95,30.28c6,3.44,19.53-8.81,19.53-15.65V86.45c0-6.84-6.42-14.93-12.39-18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M66.35,34.6c-5.9-3.4-10.69-.68-10.69,6.1v84.69c0,6.77,4.79,15,10.69,18.43L118,174.38c5.9,3.4,18.17-7.46,18.17-14.23V86.5c0-6.77-6.15-14.81-12-18.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M65.51,35.06c-5.83-3.37-10.57-.67-10.57,6v84c0,6.7,4.74,14.87,10.57,18.24l52.28,30.83c5.84,3.37,16.8-6.11,16.8-12.81V86.55c0-6.7-5.86-14.68-11.7-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M64.68,35.52c-5.78-3.33-10.46-.66-10.46,6v83.21c0,6.63,4.68,14.71,10.46,18l52.94,31.11c5.78,3.33,15.44-4.76,15.44-11.39V86.6c0-6.63-5.58-14.56-11.36-17.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M63.85,36c-5.72-3.3-10.35-.66-10.35,5.9v82.47c0,6.55,4.63,14.54,10.35,17.84l53.6,31.37c5.71,3.3,14.08-3.41,14.08-10V86.65c0-6.55-5.31-14.43-11-17.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M63,36.44c-5.65-3.27-10.23-.65-10.23,5.83V124c0,6.48,4.58,14.38,10.23,17.65l54.27,31.64c5.65,3.27,12.72-2.06,12.72-8.54v-78c0-6.48-5-14.31-10.68-17.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M62.18,36.89c-5.59-3.22-10.12-.64-10.12,5.77v81c0,6.41,4.53,14.23,10.12,17.45L117.11,173c5.58,3.23,11.36-.71,11.36-7.12V86.75c0-6.41-4.76-14.19-10.34-17.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M61.35,37.35c-5.53-3.19-10-.63-10,5.71V123.3c0,6.34,4.48,14.07,10,17.26l55.58,32.19c5.53,3.19,10,.64,10-5.7V86.8c0-6.34-4.48-14.06-10-17.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M59.67,33.62c-5.62-3.25-10.18-.65-10.18,5.8V128.3c0,6.45,4.56,14.31,10.18,17.55L113.37,177c5.62,3.25,10.17.65,10.17-5.8V82.33c0-6.45-4.55-14.31-10.17-17.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M113.37,64.78,59.67,33.62c-5.62-3.25-10.18-.65-10.18,5.8v1c0-6.45,4.56-9,10.18-5.8l53.7,31.16C119,69,123.54,76.86,123.54,83.31v-1C123.54,75.88,119,68,113.37,64.78Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "90.58 67.24 95 69.8 95 67.65 90.58 65.08 90.58 67.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "93.64 84.91 86.38 80.72 86.38 82.88 93.64 87.07 93.64 84.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "93.25 73.41 93.25 71.25 85.14 66.66 85.14 68.81 93.25 73.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "84.73 75.18 84.73 77.34 88.85 79.72 88.85 77.56 84.73 75.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "78.5 78.39 78.5 76.24 71.8 72.45 71.8 74.6 78.5 78.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "93.86 80.51 91 78.8 91 80.96 93.86 82.66 93.86 80.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "88.49 72.99 88.49 75.15 91.9 77.09 91.9 74.93 88.49 72.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "97.15 68.88 97.15 71.04 99 72.11 99 69.96 97.15 68.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "86.34 73.92 86.34 71.77 79.4 67.81 79.4 69.97 86.34 73.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "95.4 72.49 95.4 74.64 102.74 78.89 102.74 76.73 95.4 72.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "82.61 76.11 82.61 73.96 73.89 69.08 73.89 71.23 82.61 76.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "75.99 56.73 75.99 58.88 82.81 62.78 82.81 60.63 75.99 56.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "88.43 63.85 84.96 61.86 84.96 64.02 88.43 66 88.43 63.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "84.25 79.49 80.65 77.46 80.65 79.61 84.25 81.65 84.25 79.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "100.83 86.69 110.13 92.1 110.13 89.94 100.83 84.53 100.83 86.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "69.64 71.23 66.35 69.34 66.35 71.49 69.64 73.38 69.64 71.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "59.62 47.67 59.62 49.83 74.25 58.16 74.25 56.01 59.62 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "102.98 83.45 106.42 85.45 106.42 83.3 102.98 81.29 102.98 83.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "104.9 80.12 114.56 85.77 114.56 83.61 104.9 77.96 104.9 80.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "94.05 78.32 100.86 82.22 100.86 80.07 94.05 76.16 94.05 78.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "101.16 71.19 101.16 73.35 108.88 77.77 108.88 75.61 101.16 71.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "71.74 67.87 66.35 64.86 66.35 67.02 71.74 70.03 71.74 67.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "98.7 83.31 96.01 81.75 96.01 83.91 98.7 85.46 98.7 83.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "77.24 66.58 66.35 60.38 66.35 62.54 77.24 68.74 77.24 66.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "95.64 92.53 101.49 95.89 101.49 93.74 95.64 90.37 95.64 92.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "82.99 65.42 66.35 55.9 66.35 58.06 82.99 67.58 82.99 65.42"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "90.58 133.51 95 136.08 95 133.92 90.58 131.36 90.58 133.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "93.64 151.19 86.38 147 86.38 149.15 93.64 153.34 93.64 151.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "93.25 139.69 93.25 137.53 85.14 132.93 85.14 135.09 93.25 139.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "84.73 141.46 84.73 143.61 88.85 145.99 88.85 143.84 84.73 141.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "78.5 144.67 78.5 142.51 71.8 138.72 71.8 140.88 78.5 144.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "93.86 146.78 91 145.08 91 147.24 93.86 148.94 93.86 146.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "88.49 139.27 88.49 141.42 91.9 143.37 91.9 141.21 88.49 139.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "97.15 135.16 97.15 137.31 99 138.39 99 136.23 97.15 135.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "86.34 140.2 86.34 138.04 79.4 134.09 79.4 136.24 86.34 140.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "95.4 138.76 95.4 140.92 102.74 145.16 102.74 143.01 95.4 138.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "82.61 142.39 82.61 140.23 73.89 135.35 73.89 137.51 82.61 142.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "75.99 123 75.99 125.16 82.81 129.06 82.81 126.91 75.99 123"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "88.43 130.13 84.96 128.14 84.96 130.29 88.43 132.28 88.43 130.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "84.25 145.77 80.65 143.73 80.65 145.89 84.25 147.93 84.25 145.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "100.83 152.97 110.13 158.37 110.13 156.22 100.83 150.81 100.83 152.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "69.64 137.5 66.35 135.61 66.35 137.77 69.64 139.66 69.64 137.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "59.62 113.95 59.62 116.1 74.25 124.44 74.25 122.28 59.62 113.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "102.98 149.72 106.42 151.73 106.42 149.58 102.98 147.57 102.98 149.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "104.9 146.39 114.56 152.05 114.56 149.89 104.9 144.24 104.9 146.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "94.05 144.59 100.86 148.5 100.86 146.34 94.05 142.44 94.05 144.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "101.16 137.47 101.16 139.62 108.88 144.04 108.88 141.89 101.16 137.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "71.74 134.15 66.35 131.13 66.35 133.29 71.74 136.3 71.74 134.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "98.7 149.59 96.01 148.03 96.01 150.18 98.7 151.74 98.7 149.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "77.24 132.86 66.35 126.66 66.35 128.81 77.24 135.01 77.24 132.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "82.99 131.7 66.35 122.18 66.35 124.33 82.99 133.86 82.99 131.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "93.64 102.71 86.38 98.52 86.38 100.67 93.64 104.86 93.64 102.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "93.25 91.21 93.25 89.05 85.14 84.45 85.14 86.61 93.25 91.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "84.73 92.98 84.73 95.13 88.85 97.51 88.85 95.36 84.73 92.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "78.5 96.19 78.5 94.03 71.8 90.24 71.8 92.4 78.5 96.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "93.86 98.3 91 96.6 91 98.76 93.86 100.46 93.86 98.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "88.49 90.79 88.49 92.94 91.9 94.89 91.9 92.73 88.49 90.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "86.34 91.72 86.34 89.56 79.4 85.61 79.4 87.76 86.34 91.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "82.61 93.91 82.61 91.75 73.89 86.88 73.89 89.03 82.61 93.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "84.25 97.29 80.65 95.25 80.65 97.41 84.25 99.45 84.25 97.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "100.83 104.49 110.13 109.89 110.13 107.74 100.83 102.33 100.83 104.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "69.64 89.03 66.35 87.14 66.35 89.29 69.64 91.18 69.64 89.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "102.98 101.25 106.42 103.25 106.42 101.1 102.98 99.09 102.98 101.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "94.05 96.11 100.86 100.02 100.86 97.87 94.05 93.96 94.05 96.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "71.74 85.67 66.35 82.66 66.35 84.81 71.74 87.83 71.74 85.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "98.7 101.11 96.01 99.55 96.01 101.7 98.7 103.26 98.7 101.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "77.24 84.38 66.35 78.18 66.35 80.33 77.24 86.54 77.24 84.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "83.55 101.23 83.55 103.38 86.97 105.33 86.97 103.17 83.55 101.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "81.4 102.16 81.4 100 74.46 96.05 74.46 98.2 81.4 102.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "98.05 111.69 101.49 113.69 101.49 111.54 98.05 109.53 98.05 111.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "89.12 106.55 95.92 110.46 95.92 108.31 89.12 104.4 89.12 106.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "72.31 94.82 61.42 88.62 61.42 90.77 72.31 96.98 72.31 94.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "82.99 83.22 66.35 73.7 66.35 75.86 82.99 85.38 82.99 83.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "93.64 124.76 86.38 120.57 86.38 122.72 93.64 126.91 93.64 124.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "93.25 113.26 93.25 111.1 85.14 106.5 85.14 108.66 93.25 113.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "84.73 115.03 84.73 117.18 88.85 119.56 88.85 117.41 84.73 115.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "78.5 118.24 78.5 116.08 71.8 112.29 71.8 114.45 78.5 118.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "93.86 120.35 91 118.65 91 120.81 93.86 122.51 93.86 120.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-272",
    points: "88.49 112.84 88.49 114.99 91.9 116.94 91.9 114.78 88.49 112.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "86.34 113.77 86.34 111.61 79.4 107.66 79.4 109.81 86.34 113.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "82.61 115.96 82.61 113.8 73.89 108.92 73.89 111.08 82.61 115.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "84.25 119.34 80.65 117.3 80.65 119.46 84.25 121.5 84.25 119.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "100.83 126.54 110.13 131.94 110.13 129.79 100.83 124.38 100.83 126.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "69.64 111.08 66.35 109.19 66.35 111.34 69.64 113.23 69.64 111.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "102.98 123.3 106.42 125.3 106.42 123.15 102.98 121.14 102.98 123.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "94.05 118.16 100.86 122.07 100.86 119.92 94.05 116.01 94.05 118.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "71.74 107.72 66.35 104.71 66.35 106.86 71.74 109.88 71.74 107.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "98.7 123.16 96.01 121.6 96.01 123.75 98.7 125.31 98.7 123.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "77.24 106.43 66.35 100.23 66.35 102.38 77.24 108.59 77.24 106.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-283",
    points: "83.55 123.28 83.55 125.43 86.97 127.38 86.97 125.22 83.55 123.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-284",
    points: "81.4 124.21 81.4 122.05 74.46 118.1 74.46 120.25 81.4 124.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "98.05 133.74 101.49 135.74 101.49 133.59 98.05 131.58 98.05 133.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "89.12 128.6 95.92 132.51 95.92 130.36 89.12 126.45 89.12 128.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "72.31 116.87 66.09 113.31 66.09 115.46 72.31 119.03 72.31 116.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "82.99 105.27 66.35 95.75 66.35 97.91 82.99 107.43 82.99 105.27"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-289"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-290"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M59.67,180.62c-5.62-3.25-10.18-.65-10.18,5.8v36.5c0,6.45,4.56,14.3,10.18,17.55l53.7,31.16c5.62,3.24,10.17.64,10.17-5.8v-36.5c0-6.45-4.55-14.31-10.17-17.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-292"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "90.58 226.52 95 229.08 95 231.23 90.58 228.68 90.58 226.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "93.64 212.39 86.38 208.16 86.38 206 93.64 210.24 93.64 212.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "93.25 223.44 93.25 225.6 85.14 220.79 85.14 218.63 93.25 223.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "84.73 211.78 84.73 209.63 88.85 212.03 88.85 214.19 84.73 211.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "78.5 201.34 78.5 203.5 71.8 199.51 71.8 197.36 78.5 201.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "93.86 217.06 91 215.44 91 213.29 93.86 214.9 93.86 217.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "88.49 218.34 88.49 216.19 91.9 218.2 91.9 220.35 88.49 218.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "97.15 232.5 97.15 230.34 99 231.42 99 233.57 97.15 232.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "86.34 214.91 86.34 217.07 79.4 212.97 79.4 210.81 86.34 214.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "95.4 226.86 95.4 224.71 102.74 228.99 102.74 231.14 95.4 226.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-303",
    points: "82.61 208.39 82.61 210.55 73.89 205.31 73.89 203.16 82.61 208.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "75.99 220.1 75.99 217.94 82.81 221.95 82.81 224.11 75.99 220.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "88.43 227.41 84.96 225.37 84.96 223.22 88.43 225.26 88.43 227.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "84.25 206.92 80.65 204.78 80.65 202.62 84.25 204.77 84.25 206.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-307",
    points: "100.83 218.96 110.13 224.35 110.13 226.5 100.83 221.11 100.83 218.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "69.64 198.23 66.35 196.31 66.35 194.15 69.64 196.08 69.64 198.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "59.62 210.16 59.62 208 74.25 216.64 74.25 218.8 59.62 210.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "102.98 224.7 106.42 226.69 106.42 228.84 102.98 226.85 102.98 224.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "104.9 230.25 114.56 235.82 114.56 237.97 104.9 232.41 104.9 230.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "94.05 219.47 100.86 223.46 100.86 225.62 94.05 221.63 94.05 219.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-313",
    points: "101.16 234.84 101.16 232.68 108.88 237.22 108.88 239.38 101.16 234.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-314",
    points: "71.74 204.02 66.35 200.78 66.35 198.63 71.74 201.86 71.74 204.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "98.7 219.88 96.01 218.31 96.01 216.16 98.7 217.72 98.7 219.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "77.24 211.69 66.35 205.26 66.35 203.11 77.24 209.54 77.24 211.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "82.99 219.52 66.35 209.74 66.35 207.59 82.99 217.36 82.99 219.52"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-318"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M5.37,51.86A11,11,0,0,1,2.6,48.24a9.28,9.28,0,0,1-.83-3.81V42.1a4.51,4.51,0,0,0-.43-2A3.37,3.37,0,0,0,0,38.67v-2.3c.6.34,1,.39,1.34.14A2,2,0,0,0,1.77,35V32.65a4.14,4.14,0,0,1,.83-2.86c.55-.6,1.47-.73,2.77-.4l.56,2.12a1,1,0,0,0-1.2.58,4.84,4.84,0,0,0-.35,2.06v2.33a3.42,3.42,0,0,1-.44,1.87A1.53,1.53,0,0,1,2.59,39a7.7,7.7,0,0,1,1.35,2.24,6.78,6.78,0,0,1,.44,2.35v2.34a8.26,8.26,0,0,0,.35,2.46,4.9,4.9,0,0,0,1.2,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-320",
    d: "M56.39,77.38a1,1,0,0,0,1.2-.58,4.69,4.69,0,0,0,.35-2.06V72.41a3.22,3.22,0,0,1,.46-1.85,1.57,1.57,0,0,1,1.41-.63,7.3,7.3,0,0,1-1.41-2.25,6.71,6.71,0,0,1-.46-2.39V63a8,8,0,0,0-.35-2.47,4.6,4.6,0,0,0-1.2-2L57,57.05a11,11,0,0,1,2.78,3.6,9.28,9.28,0,0,1,.83,3.81v2.33a4.51,4.51,0,0,0,.43,2,3.19,3.19,0,0,0,1.35,1.4v2.31Q61.41,72,61,72.39a2,2,0,0,0-.43,1.52v2.33a4.12,4.12,0,0,1-.83,2.86c-.56.61-1.48.74-2.78.42Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-321",
    points: "47.17 69.09 47.17 56.8 53.81 66.78 47.17 69.09 47.17 69.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "38.13 63.92 38.13 51.63 44.77 61.61 38.13 63.92 38.13 63.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "29.1 58.76 29.1 46.46 35.73 56.44 29.1 58.76 29.1 58.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "20.06 53.59 20.06 41.29 26.7 51.27 20.06 53.59 20.06 53.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-324",
    points: "11.02 48.42 11.02 36.12 17.66 46.1 11.02 48.42 11.02 48.42"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M181.76,116.11c-8.85-5.11-16-1-16,9.13V141.3c0,10.16,7.17,22.53,16,27.64l91.84,53.23c8.85,5.1,19.57.45,19.57-9.7V196.41c0-10.16-10.72-22-19.57-27.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-326",
    d: "M181.28,116.82c-8.8-5.08-15.94-1-15.94,9.09v14.93c0,10.11,7.14,22.42,15.94,27.51l91.32,52.92c8.81,5.08,19.17.5,19.17-9.6V196.74c0-10.11-10.36-21.91-19.17-27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-327",
    d: "M180.81,117.53c-8.76-5.06-15.87-1-15.87,9v13.81c0,10.05,7.11,22.31,15.87,27.37l90.79,52.62c8.76,5.05,18.77.55,18.77-9.51V197.06c0-10.05-10-21.85-18.77-26.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M180.33,118.25c-8.72-5-15.79-1-15.79,9v12.68c0,10,7.07,22.2,15.79,27.24l90.27,52.31c8.72,5,18.37.6,18.37-9.41V197.39c0-10-9.65-21.79-18.37-26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-329",
    d: "M179.86,119c-8.68-5-15.71-1-15.71,9v11.56c0,10,7,22.09,15.71,27.1l89.73,52c8.68,5,18,.64,18-9.32V197.72c0-10-9.29-21.74-18-26.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-330",
    d: "M179.38,119.68c-8.63-5-15.63-1-15.63,8.91V139c0,9.91,7,22,15.63,27l89.21,51.71c8.64,5,17.57.69,17.57-9.22V198c0-9.91-8.93-21.67-17.57-26.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-331",
    d: "M178.91,120.39c-8.59-5-15.56-1-15.56,8.87v9.3c0,9.86,7,21.87,15.56,26.83l88.68,51.41c8.59,5,17.17.73,17.17-9.13v-9.3c0-9.86-8.58-21.62-17.17-26.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M178.43,121.11c-8.55-4.94-15.48-1-15.48,8.82v8.18c0,9.81,6.93,21.76,15.48,26.69l88.16,51.1c8.55,4.94,16.77.78,16.77-9V198.7c0-9.81-8.22-21.56-16.77-26.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-333",
    d: "M178,121.82c-8.51-4.91-15.4-1-15.4,8.78v7.05c0,9.76,6.89,21.65,15.4,26.56L265.59,215c8.5,4.91,16.36.82,16.36-8.94v-7c0-9.76-7.86-21.5-16.36-26.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-334",
    d: "M177.48,122.53c-8.46-4.88-15.32-1-15.32,8.74v5.92c0,9.71,6.86,21.54,15.32,26.43l87.11,50.49c8.46,4.89,16,.87,16-8.84v-5.92c0-9.71-7.5-21.44-16-26.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M177,123.25c-8.41-4.86-15.24-1-15.24,8.69v4.8c0,9.66,6.83,21.43,15.24,26.29l86.58,50.19c8.42,4.86,15.57.91,15.57-8.75v-4.8c0-9.66-7.15-21.37-15.57-26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M176.53,124c-8.38-4.83-15.17-1-15.17,8.65v3.67c0,9.61,6.79,21.32,15.17,26.16l86,49.88c8.38,4.84,15.17,1,15.17-8.64V200c0-9.61-6.79-21.32-15.17-26.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-337",
    d: "M272.74,221.44,172.07,163.13c-7.23-4.17-13.16-15.49-13.16-25.14v-6.86c0-9.65,5.93-14.13,13.16-9.95l100.67,58.31c7.24,4.18,13.16,15.5,13.16,25.15v6.85C285.9,221.15,280,225.62,272.74,221.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-338",
    d: "M272.74,179.49,172.07,121.18c-7.23-4.18-13.16.3-13.16,9.95v1.48c0-9.65,5.93-14.13,13.16-10L272.74,181c7.24,4.18,13.16,15.49,13.16,25.15v-1.48C285.9,195,280,183.67,272.74,179.49Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-339",
    cx: 190.35,
    cy: 153.98,
    rx: 10.69,
    ry: 18.52,
    transform: "translate(-51.69 117.11) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-340",
    cx: 221.11,
    cy: 172.29,
    rx: 10.69,
    ry: 18.52,
    transform: "translate(-56.73 135.14) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-341",
    cx: 252.11,
    cy: 189.96,
    rx: 10.69,
    ry: 18.52,
    transform: "translate(-61.41 153.2) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-342"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-343",
    d: "M191,168.72c-7.25-4.19-13.13-14.33-13.13-22.65,0-4.1,1.43-7,3.74-8.37-2.7,1.2-4.41,4.22-4.41,8.7,0,8.32,5.88,18.47,13.14,22.65,3.68,2.13,7,2.31,9.39.88C197.42,171,194.37,170.66,191,168.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-344",
    d: "M221.77,187c-7.25-4.19-13.13-14.33-13.13-22.65,0-4.1,1.43-7,3.74-8.37-2.7,1.2-4.41,4.22-4.41,8.7,0,8.32,5.88,18.47,13.14,22.66,3.68,2.12,7,2.3,9.39.87C228.18,189.28,225.13,189,221.77,187Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-345",
    d: "M252.77,204.7c-7.25-4.19-13.13-14.33-13.13-22.66,0-4.09,1.43-7,3.74-8.36-2.7,1.2-4.41,4.22-4.41,8.7,0,8.32,5.88,18.46,13.14,22.65,3.68,2.13,7,2.3,9.39.88C259.18,206.94,256.13,206.64,252.77,204.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-346",
    d: "M270.25,193.42V206.9l7.28-2.54Zm-98-43.61V136.34L165,138.87Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-347",
    d: "M183.14,157.66a7.6,7.6,0,0,1-.91-3.73v-9.49c0-1.38.3-2.27.91-2.68s1.49-.27,2.65.39a6.87,6.87,0,0,1,2.65,2.67,7.6,7.6,0,0,1,.91,3.73v1.87l-2.28-1.32v-2a2.48,2.48,0,0,0-1.21-2.34c-.81-.47-1.21-.15-1.21.94v9.87a2.45,2.45,0,0,0,1.21,2.31c.8.47,1.21.16,1.21-.92v-2.7l2.28,1.32V158c0,1.38-.3,2.28-.91,2.68s-1.49.28-2.65-.39A6.87,6.87,0,0,1,183.14,157.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-348",
    d: "M191.33,158.23l-1.07-.63.17-1.86,1.08.62.42-4.38-1.1-.63.17-1.87,1.1.64.38-3.85,1.91,1.1-.37,3.85,1.56.9.37-3.85,1.92,1.11-.38,3.85,1.12.64-.17,1.87-1.12-.65-.42,4.38,1.12.65-.18,1.87-1.12-.65-.46,4.78L194.35,165l.46-4.78-1.56-.9-.47,4.78-1.91-1.1Zm3.65.14.42-4.38-1.56-.9-.42,4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-349",
    d: "M215.26,178v-2.52a5.29,5.29,0,0,0,.79.56c.48.28.84.35,1.08.2s.35-.5.35-1.07V161.57l2.42,1.4v13.47q0,2.17-.87,2.73c-.58.38-1.46.22-2.65-.47A8.36,8.36,0,0,1,215.26,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-350",
    d: "M222.12,181a7.88,7.88,0,0,1-.9-3.81v-1l2.29,1.32v1.21a2.6,2.6,0,0,0,1.25,2.44c.41.24.72.28.94.12s.31-.54.31-1.16a5.77,5.77,0,0,0-.44-2.21,19.18,19.18,0,0,0-1.62-3,22.87,22.87,0,0,1-2.09-3.94,8.67,8.67,0,0,1-.6-3.11c0-1.39.31-2.3.93-2.71s1.51-.27,2.68.4a6.68,6.68,0,0,1,2.63,2.67,8,8,0,0,1,.89,3.81v.73l-2.29-1.32v-.91a3.15,3.15,0,0,0-.31-1.5,2.2,2.2,0,0,0-.9-.94c-.8-.47-1.21-.13-1.21,1a5.36,5.36,0,0,0,.45,2,21.13,21.13,0,0,0,1.64,3,21.6,21.6,0,0,1,2.09,4,9.35,9.35,0,0,1,.57,3.23q0,2.18-.93,2.79c-.62.42-1.53.28-2.72-.4A6.87,6.87,0,0,1,222.12,181Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-351"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-352",
    d: "M248.5,178.67l3.75,2.16a7.44,7.44,0,0,1,2.85,2.69,7.33,7.33,0,0,1,.9,3.73v1.13c0,1.92-.55,2.81-1.65,2.69v.05a4.8,4.8,0,0,1,1.3,2A9.55,9.55,0,0,1,256,196v3.24c0,.53,0,1,.05,1.31a5.19,5.19,0,0,0,.23,1.09l-2.57-1.48a5.89,5.89,0,0,1-.19-.95c0-.29,0-.77,0-1.46v-3.37a4.43,4.43,0,0,0-.36-2,3,3,0,0,0-1.23-1.21l-.88-.5v7.91l-2.53-1.46Zm3.45,9.91q.77.43,1.14.21c.26-.16.38-.58.38-1.29v-1.42a3.61,3.61,0,0,0-.31-1.63,2.4,2.4,0,0,0-1-1l-1.15-.66v5.28Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-353"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-354"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-355",
    d: "M272.74,282.44,172.07,224.13c-7.23-4.17-13.16-15.49-13.16-25.14v-6.86c0-9.65,5.93-14.13,13.16-9.95l100.67,58.31c7.24,4.18,13.16,15.5,13.16,25.15v6.85C285.9,282.15,280,286.62,272.74,282.44Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-356",
    cx: 221.11,
    cy: 233.29,
    rx: 10.69,
    ry: 18.52,
    transform: "translate(-87.52 143.48) rotate(-30.31)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-357",
    d: "M216.38,221.88a6.83,6.83,0,0,1,2.65,2.6,7.56,7.56,0,0,1,.87,3.73v13.48l-2.42-1.4V226.73a3,3,0,0,0-.35-1.48,2.92,2.92,0,0,0-1.08-1,3.79,3.79,0,0,0-.79-.36v-2.53A7.71,7.71,0,0,1,216.38,221.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-358",
    d: "M224.78,226.61a7.11,7.11,0,0,1,2.72,2.75,7.91,7.91,0,0,1,.93,3.87,4.82,4.82,0,0,1-.57,2.57,4.37,4.37,0,0,1-2.09,1.54,4.1,4.1,0,0,0-1.64,1.06,2.4,2.4,0,0,0-.45,1.53,2.56,2.56,0,0,0,1.21,2.4c.4.23.7.26.9.11s.31-.54.31-1.15v-.91l2.29,1.33v.73c0,1.43-.3,2.36-.89,2.78s-1.47.29-2.63-.38a7,7,0,0,1-2.68-2.71,7.73,7.73,0,0,1-.93-3.78,4.22,4.22,0,0,1,.6-2.42,4.59,4.59,0,0,1,2.09-1.52,3.85,3.85,0,0,0,1.62-1.09,2.76,2.76,0,0,0,.44-1.7,3.28,3.28,0,0,0-.31-1.53,2.35,2.35,0,0,0-.94-1c-.83-.49-1.25-.16-1.25,1v1.21L221.22,230v-1c0-1.43.3-2.35.9-2.77S223.61,225.93,224.78,226.61Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M200.89,26.23l3.56,2.06A7,7,0,0,1,207.16,31a7.71,7.71,0,0,1,.9,3.78v1.74c0,1.43-.3,2.34-.9,2.74s-1.51.24-2.71-.46l-1.14-.66v7.2l-2.42-1.4Zm3.56,10c.4.23.69.27.89.14s.3-.51.3-1.12V33.17a3,3,0,0,0-.3-1.46,2.26,2.26,0,0,0-.89-.9l-1.14-.66v5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M209.38,31.13l2.42,1.4v7.19l2.59,1.5V34l2.42,1.4V53.09l-2.42-1.39v-8l-2.59-1.5v8l-2.42-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M218.61,36.47l3.57,2.06a6.93,6.93,0,0,1,2.7,2.67,7.68,7.68,0,0,1,.91,3.77v1.75c0,1.43-.31,2.34-.91,2.73s-1.5.24-2.7-.45L221,48.34v7.19l-2.42-1.39Zm3.57,10c.39.22.69.27.89.13s.3-.51.3-1.11V43.4a3.08,3.08,0,0,0-.3-1.46,2.37,2.37,0,0,0-.89-.89L221,40.39v5.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M276.58,165.3a7.71,7.71,0,0,1-.91-3.73v-9.49c0-1.38.31-2.28.91-2.68s1.5-.28,2.65.39a6.89,6.89,0,0,1,2.66,2.67,7.71,7.71,0,0,1,.91,3.73v1.87l-2.29-1.32v-2.05a2.46,2.46,0,0,0-1.21-2.33c-.81-.47-1.21-.16-1.21.94v9.87a2.46,2.46,0,0,0,1.21,2.31c.81.47,1.21.16,1.21-.92v-2.7l2.29,1.32v2.5c0,1.38-.31,2.27-.91,2.68s-1.5.27-2.66-.39A6.93,6.93,0,0,1,276.58,165.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M284.78,170a7.92,7.92,0,0,1-.9-3.82v-1l2.28,1.32v1.22a2.6,2.6,0,0,0,1.26,2.44q.61.35.93.12c.21-.16.32-.54.32-1.17a6,6,0,0,0-.44-2.21,19.89,19.89,0,0,0-1.63-3,24.38,24.38,0,0,1-2.09-3.94,8.87,8.87,0,0,1-.59-3.11c0-1.4.31-2.3.92-2.71s1.51-.28,2.69.4a6.75,6.75,0,0,1,2.63,2.67,8,8,0,0,1,.89,3.81v.73l-2.29-1.32v-.91a3.22,3.22,0,0,0-.31-1.51,2.3,2.3,0,0,0-.9-.93c-.81-.47-1.21-.14-1.21,1a5.4,5.4,0,0,0,.45,2,21.13,21.13,0,0,0,1.64,3,21.6,21.6,0,0,1,2.09,4,9.35,9.35,0,0,1,.57,3.23q0,2.18-.93,2.79c-.63.41-1.53.28-2.72-.41A6.78,6.78,0,0,1,284.78,170Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-359",
    d: "M293,174.74a7.88,7.88,0,0,1-.9-3.81v-1l2.29,1.32v1.21a2.58,2.58,0,0,0,1.25,2.44q.61.36.93.12c.22-.15.32-.54.32-1.16a5.77,5.77,0,0,0-.44-2.21,18.73,18.73,0,0,0-1.62-3,22.9,22.9,0,0,1-2.09-3.95,8.63,8.63,0,0,1-.6-3.11c0-1.39.31-2.3.93-2.71s1.51-.27,2.68.41a6.66,6.66,0,0,1,2.63,2.66,8,8,0,0,1,.89,3.81v.73l-2.29-1.32v-.91a3.21,3.21,0,0,0-.31-1.5,2.2,2.2,0,0,0-.9-.94c-.81-.46-1.21-.13-1.21,1a5.45,5.45,0,0,0,.45,2.06,21.14,21.14,0,0,0,1.64,3,22.26,22.26,0,0,1,2.09,4,9.35,9.35,0,0,1,.57,3.23q0,2.18-.93,2.79c-.63.42-1.53.28-2.72-.4A6.87,6.87,0,0,1,293,174.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M254.4,233.1a7.88,7.88,0,0,1-.9-3.81v-1l2.29,1.32v1.21a2.6,2.6,0,0,0,1.25,2.44c.41.24.72.28.94.12s.32-.54.32-1.16a6,6,0,0,0-.44-2.21,20.34,20.34,0,0,0-1.63-3,23.6,23.6,0,0,1-2.09-3.94,8.65,8.65,0,0,1-.59-3.11c0-1.39.3-2.3.92-2.71s1.51-.27,2.68.4a6.68,6.68,0,0,1,2.63,2.67,7.88,7.88,0,0,1,.89,3.81v.73l-2.29-1.32v-.91a3.28,3.28,0,0,0-.3-1.5,2.29,2.29,0,0,0-.91-.94c-.8-.47-1.21-.13-1.21,1a5.47,5.47,0,0,0,.46,2.06,21.43,21.43,0,0,0,1.63,3,21,21,0,0,1,2.09,4,9.13,9.13,0,0,1,.58,3.23c0,1.45-.32,2.38-.94,2.79s-1.53.28-2.72-.4A6.87,6.87,0,0,1,254.4,233.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M267.2,241.34a4.46,4.46,0,0,1-1.6-.63,7,7,0,0,1-2.73-2.73,7.79,7.79,0,0,1-.94-3.83v-9.29c0-1.41.31-2.32.94-2.73s1.54-.28,2.73.41a7.11,7.11,0,0,1,2.73,2.74,7.72,7.72,0,0,1,.94,3.82v9.29a3.7,3.7,0,0,1-.68,2.51,1.55,1.55,0,0,0,.33.52,2.64,2.64,0,0,0,.57.4l.38.22v2.52l-.64-.36A4.07,4.07,0,0,1,267.2,241.34Zm-.35-4.17v-9.64a2.64,2.64,0,0,0-1.25-2.47c-.84-.48-1.25-.14-1.25,1v9.64a2.61,2.61,0,0,0,1.25,2.47C266.43,238.67,266.85,238.33,266.85,237.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-360",
    d: "M270.9,225.85l2.42,1.4v15.14l4,2.3v2.53l-6.4-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M6.21,104.79,3.54,94.62,6.1,96.1l1.62,6.64,0,0L9.44,98l2.29,1.32-2.67,7.09,2.8,10.65-2.55-1.47-1.76-7.18,0,0-1.8,5.12-2.29-1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M13,100.08l3.46,2L18,115.61l.05,0,1.54-11.76,3.45,2v17.66l-2.29-1.32V108.85l0,0-1.76,12.36-2-1.17-1.76-14.39-.05,0V119L13,117.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-361",
    d: "M24.84,106.92l2.41,1.39v15.15l4,2.3v2.52l-6.4-3.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-362"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M154.7,63.77a.61.61,0,0,1-.19-.2.55.55,0,0,1-.09-.29V62a.33.33,0,0,1,.09-.26.58.58,0,0,1,.26-.11l3.38-.65-3.38-4.54a2.86,2.86,0,0,1-.26-.42.79.79,0,0,1-.09-.38V54.44a.23.23,0,0,1,.08-.21.19.19,0,0,1,.2,0,.87.87,0,0,1,.28.31L159.72,61a2.9,2.9,0,0,1,.31.52,1.12,1.12,0,0,1,.09.44v.38a.5.5,0,0,1-.09.33.6.6,0,0,1-.31.15l-4.74,1A.35.35,0,0,1,154.7,63.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M152.55,64.75l-.91-.52a.81.81,0,0,1-.28-.27,1.3,1.3,0,0,1-.15-.32l-4.78-15.85a.65.65,0,0,1,0-.19c0-.1,0-.17.08-.2s.12,0,.21,0l.91.52a1,1,0,0,1,.28.27,1.25,1.25,0,0,1,.16.33l4.75,15.84a.58.58,0,0,1,0,.19.21.21,0,0,1-.08.19A.19.19,0,0,1,152.55,64.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-363",
    d: "M144.55,57.9a.78.78,0,0,1-.28-.29l-4.74-6.45a2.35,2.35,0,0,1-.3-.5,1,1,0,0,1-.1-.44v-.38a.55.55,0,0,1,.09-.34.53.53,0,0,1,.31-.15l4.74-1a.31.31,0,0,1,.28,0,.63.63,0,0,1,.28.5v1.23a.35.35,0,0,1-.09.28.49.49,0,0,1-.26.11l-3.38.65,3.38,4.55a2.4,2.4,0,0,1,.26.41.8.8,0,0,1,.09.36v1.25a.19.19,0,0,1-.09.19A.17.17,0,0,1,144.55,57.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-364",
    points: "59.62 47.67 59.62 49.83 74.25 58.16 74.25 56.01 59.62 47.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-365",
    points: "59.62 113.95 59.62 116.1 74.25 124.44 74.25 122.28 59.62 113.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-366",
    points: "72.31 94.82 61.42 88.62 61.42 90.77 72.31 96.98 72.31 94.82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftware01);
export default __webpack_public_path__ + "static/media/software-01.a98bf8297ae5764801f8405e9d2af105.svg";
export { ForwardRef as ReactComponent };